/*!
 * Bootstrap v3.3.7 (http://getbootstrap.com)
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under the MIT license
 */
if("undefined"==typeof jQuery)throw new Error("Bootstrap's JavaScript requires jQuery");+function(a){"use strict";var b=a.fn.jquery.split(" ")[0].split(".");if(b[0]<2&&b[1]<9||1==b[0]&&9==b[1]&&b[2]<1||b[0]>3)throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4")}(jQuery),+function(a){"use strict";function b(){var a=document.createElement("bootstrap"),b={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd otransitionend",transition:"transitionend"};for(var c in b)if(void 0!==a.style[c])return{end:b[c]};return!1}a.fn.emulateTransitionEnd=function(b){var c=!1,d=this;a(this).one("bsTransitionEnd",function(){c=!0});var e=function(){c||a(d).trigger(a.support.transition.end)};return setTimeout(e,b),this},a(function(){a.support.transition=b(),a.support.transition&&(a.event.special.bsTransitionEnd={bindType:a.support.transition.end,delegateType:a.support.transition.end,handle:function(b){if(a(b.target).is(this))return b.handleObj.handler.apply(this,arguments)}})})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var c=a(this),e=c.data("bs.alert");e||c.data("bs.alert",e=new d(this)),"string"==typeof b&&e[b].call(c)})}var c='[data-dismiss="alert"]',d=function(b){a(b).on("click",c,this.close)};d.VERSION="3.3.7",d.TRANSITION_DURATION=150,d.prototype.close=function(b){function c(){g.detach().trigger("closed.bs.alert").remove()}var e=a(this),f=e.attr("data-target");f||(f=e.attr("href"),f=f&&f.replace(/.*(?=#[^\s]*$)/,""));var g=a("#"===f?[]:f);b&&b.preventDefault(),g.length||(g=e.closest(".alert")),g.trigger(b=a.Event("close.bs.alert")),b.isDefaultPrevented()||(g.removeClass("in"),a.support.transition&&g.hasClass("fade")?g.one("bsTransitionEnd",c).emulateTransitionEnd(d.TRANSITION_DURATION):c())};var e=a.fn.alert;a.fn.alert=b,a.fn.alert.Constructor=d,a.fn.alert.noConflict=function(){return a.fn.alert=e,this},a(document).on("click.bs.alert.data-api",c,d.prototype.close)}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.button"),f="object"==typeof b&&b;e||d.data("bs.button",e=new c(this,f)),"toggle"==b?e.toggle():b&&e.setState(b)})}var c=function(b,d){this.$element=a(b),this.options=a.extend({},c.DEFAULTS,d),this.isLoading=!1};c.VERSION="3.3.7",c.DEFAULTS={loadingText:"loading..."},c.prototype.setState=function(b){var c="disabled",d=this.$element,e=d.is("input")?"val":"html",f=d.data();b+="Text",null==f.resetText&&d.data("resetText",d[e]()),setTimeout(a.proxy(function(){d[e](null==f[b]?this.options[b]:f[b]),"loadingText"==b?(this.isLoading=!0,d.addClass(c).attr(c,c).prop(c,!0)):this.isLoading&&(this.isLoading=!1,d.removeClass(c).removeAttr(c).prop(c,!1))},this),0)},c.prototype.toggle=function(){var a=!0,b=this.$element.closest('[data-toggle="buttons"]');if(b.length){var c=this.$element.find("input");"radio"==c.prop("type")?(c.prop("checked")&&(a=!1),b.find(".active").removeClass("active"),this.$element.addClass("active")):"checkbox"==c.prop("type")&&(c.prop("checked")!==this.$element.hasClass("active")&&(a=!1),this.$element.toggleClass("active")),c.prop("checked",this.$element.hasClass("active")),a&&c.trigger("change")}else this.$element.attr("aria-pressed",!this.$element.hasClass("active")),this.$element.toggleClass("active")};var d=a.fn.button;a.fn.button=b,a.fn.button.Constructor=c,a.fn.button.noConflict=function(){return a.fn.button=d,this},a(document).on("click.bs.button.data-api",'[data-toggle^="button"]',function(c){var d=a(c.target).closest(".btn");b.call(d,"toggle"),a(c.target).is('input[type="radio"], input[type="checkbox"]')||(c.preventDefault(),d.is("input,button")?d.trigger("focus"):d.find("input:visible,button:visible").first().trigger("focus"))}).on("focus.bs.button.data-api blur.bs.button.data-api",'[data-toggle^="button"]',function(b){a(b.target).closest(".btn").toggleClass("focus",/^focus(in)?$/.test(b.type))})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.carousel"),f=a.extend({},c.DEFAULTS,d.data(),"object"==typeof b&&b),g="string"==typeof b?b:f.slide;e||d.data("bs.carousel",e=new c(this,f)),"number"==typeof b?e.to(b):g?e[g]():f.interval&&e.pause().cycle()})}var c=function(b,c){this.$element=a(b),this.$indicators=this.$element.find(".carousel-indicators"),this.options=c,this.paused=null,this.sliding=null,this.interval=null,this.$active=null,this.$items=null,this.options.keyboard&&this.$element.on("keydown.bs.carousel",a.proxy(this.keydown,this)),"hover"==this.options.pause&&!("ontouchstart"in document.documentElement)&&this.$element.on("mouseenter.bs.carousel",a.proxy(this.pause,this)).on("mouseleave.bs.carousel",a.proxy(this.cycle,this))};c.VERSION="3.3.7",c.TRANSITION_DURATION=600,c.DEFAULTS={interval:5e3,pause:"hover",wrap:!0,keyboard:!0},c.prototype.keydown=function(a){if(!/input|textarea/i.test(a.target.tagName)){switch(a.which){case 37:this.prev();break;case 39:this.next();break;default:return}a.preventDefault()}},c.prototype.cycle=function(b){return b||(this.paused=!1),this.interval&&clearInterval(this.interval),this.options.interval&&!this.paused&&(this.interval=setInterval(a.proxy(this.next,this),this.options.interval)),this},c.prototype.getItemIndex=function(a){return this.$items=a.parent().children(".item"),this.$items.index(a||this.$active)},c.prototype.getItemForDirection=function(a,b){var c=this.getItemIndex(b),d="prev"==a&&0===c||"next"==a&&c==this.$items.length-1;if(d&&!this.options.wrap)return b;var e="prev"==a?-1:1,f=(c+e)%this.$items.length;return this.$items.eq(f)},c.prototype.to=function(a){var b=this,c=this.getItemIndex(this.$active=this.$element.find(".item.active"));if(!(a>this.$items.length-1||a<0))return this.sliding?this.$element.one("slid.bs.carousel",function(){b.to(a)}):c==a?this.pause().cycle():this.slide(a>c?"next":"prev",this.$items.eq(a))},c.prototype.pause=function(b){return b||(this.paused=!0),this.$element.find(".next, .prev").length&&a.support.transition&&(this.$element.trigger(a.support.transition.end),this.cycle(!0)),this.interval=clearInterval(this.interval),this},c.prototype.next=function(){if(!this.sliding)return this.slide("next")},c.prototype.prev=function(){if(!this.sliding)return this.slide("prev")},c.prototype.slide=function(b,d){var e=this.$element.find(".item.active"),f=d||this.getItemForDirection(b,e),g=this.interval,h="next"==b?"left":"right",i=this;if(f.hasClass("active"))return this.sliding=!1;var j=f[0],k=a.Event("slide.bs.carousel",{relatedTarget:j,direction:h});if(this.$element.trigger(k),!k.isDefaultPrevented()){if(this.sliding=!0,g&&this.pause(),this.$indicators.length){this.$indicators.find(".active").removeClass("active");var l=a(this.$indicators.children()[this.getItemIndex(f)]);l&&l.addClass("active")}var m=a.Event("slid.bs.carousel",{relatedTarget:j,direction:h});return a.support.transition&&this.$element.hasClass("slide")?(f.addClass(b),f[0].offsetWidth,e.addClass(h),f.addClass(h),e.one("bsTransitionEnd",function(){f.removeClass([b,h].join(" ")).addClass("active"),e.removeClass(["active",h].join(" ")),i.sliding=!1,setTimeout(function(){i.$element.trigger(m)},0)}).emulateTransitionEnd(c.TRANSITION_DURATION)):(e.removeClass("active"),f.addClass("active"),this.sliding=!1,this.$element.trigger(m)),g&&this.cycle(),this}};var d=a.fn.carousel;a.fn.carousel=b,a.fn.carousel.Constructor=c,a.fn.carousel.noConflict=function(){return a.fn.carousel=d,this};var e=function(c){var d,e=a(this),f=a(e.attr("data-target")||(d=e.attr("href"))&&d.replace(/.*(?=#[^\s]+$)/,""));if(f.hasClass("carousel")){var g=a.extend({},f.data(),e.data()),h=e.attr("data-slide-to");h&&(g.interval=!1),b.call(f,g),h&&f.data("bs.carousel").to(h),c.preventDefault()}};a(document).on("click.bs.carousel.data-api","[data-slide]",e).on("click.bs.carousel.data-api","[data-slide-to]",e),a(window).on("load",function(){a('[data-ride="carousel"]').each(function(){var c=a(this);b.call(c,c.data())})})}(jQuery),+function(a){"use strict";function b(b){var c,d=b.attr("data-target")||(c=b.attr("href"))&&c.replace(/.*(?=#[^\s]+$)/,"");return a(d)}function c(b){return this.each(function(){var c=a(this),e=c.data("bs.collapse"),f=a.extend({},d.DEFAULTS,c.data(),"object"==typeof b&&b);!e&&f.toggle&&/show|hide/.test(b)&&(f.toggle=!1),e||c.data("bs.collapse",e=new d(this,f)),"string"==typeof b&&e[b]()})}var d=function(b,c){this.$element=a(b),this.options=a.extend({},d.DEFAULTS,c),this.$trigger=a('[data-toggle="collapse"][href="#'+b.id+'"],[data-toggle="collapse"][data-target="#'+b.id+'"]'),this.transitioning=null,this.options.parent?this.$parent=this.getParent():this.addAriaAndCollapsedClass(this.$element,this.$trigger),this.options.toggle&&this.toggle()};d.VERSION="3.3.7",d.TRANSITION_DURATION=350,d.DEFAULTS={toggle:!0},d.prototype.dimension=function(){var a=this.$element.hasClass("width");return a?"width":"height"},d.prototype.show=function(){if(!this.transitioning&&!this.$element.hasClass("in")){var b,e=this.$parent&&this.$parent.children(".panel").children(".in, .collapsing");if(!(e&&e.length&&(b=e.data("bs.collapse"),b&&b.transitioning))){var f=a.Event("show.bs.collapse");if(this.$element.trigger(f),!f.isDefaultPrevented()){e&&e.length&&(c.call(e,"hide"),b||e.data("bs.collapse",null));var g=this.dimension();this.$element.removeClass("collapse").addClass("collapsing")[g](0).attr("aria-expanded",!0),this.$trigger.removeClass("collapsed").attr("aria-expanded",!0),this.transitioning=1;var h=function(){this.$element.removeClass("collapsing").addClass("collapse in")[g](""),this.transitioning=0,this.$element.trigger("shown.bs.collapse")};if(!a.support.transition)return h.call(this);var i=a.camelCase(["scroll",g].join("-"));this.$element.one("bsTransitionEnd",a.proxy(h,this)).emulateTransitionEnd(d.TRANSITION_DURATION)[g](this.$element[0][i])}}}},d.prototype.hide=function(){if(!this.transitioning&&this.$element.hasClass("in")){var b=a.Event("hide.bs.collapse");if(this.$element.trigger(b),!b.isDefaultPrevented()){var c=this.dimension();this.$element[c](this.$element[c]())[0].offsetHeight,this.$element.addClass("collapsing").removeClass("collapse in").attr("aria-expanded",!1),this.$trigger.addClass("collapsed").attr("aria-expanded",!1),this.transitioning=1;var e=function(){this.transitioning=0,this.$element.removeClass("collapsing").addClass("collapse").trigger("hidden.bs.collapse")};return a.support.transition?void this.$element[c](0).one("bsTransitionEnd",a.proxy(e,this)).emulateTransitionEnd(d.TRANSITION_DURATION):e.call(this)}}},d.prototype.toggle=function(){this[this.$element.hasClass("in")?"hide":"show"]()},d.prototype.getParent=function(){return a(this.options.parent).find('[data-toggle="collapse"][data-parent="'+this.options.parent+'"]').each(a.proxy(function(c,d){var e=a(d);this.addAriaAndCollapsedClass(b(e),e)},this)).end()},d.prototype.addAriaAndCollapsedClass=function(a,b){var c=a.hasClass("in");a.attr("aria-expanded",c),b.toggleClass("collapsed",!c).attr("aria-expanded",c)};var e=a.fn.collapse;a.fn.collapse=c,a.fn.collapse.Constructor=d,a.fn.collapse.noConflict=function(){return a.fn.collapse=e,this},a(document).on("click.bs.collapse.data-api",'[data-toggle="collapse"]',function(d){var e=a(this);e.attr("data-target")||d.preventDefault();var f=b(e),g=f.data("bs.collapse"),h=g?"toggle":e.data();c.call(f,h)})}(jQuery),+function(a){"use strict";function b(b){var c=b.attr("data-target");c||(c=b.attr("href"),c=c&&/#[A-Za-z]/.test(c)&&c.replace(/.*(?=#[^\s]*$)/,""));var d=c&&a(c);return d&&d.length?d:b.parent()}function c(c){c&&3===c.which||(a(e).remove(),a(f).each(function(){var d=a(this),e=b(d),f={relatedTarget:this};e.hasClass("open")&&(c&&"click"==c.type&&/input|textarea/i.test(c.target.tagName)&&a.contains(e[0],c.target)||(e.trigger(c=a.Event("hide.bs.dropdown",f)),c.isDefaultPrevented()||(d.attr("aria-expanded","false"),e.removeClass("open").trigger(a.Event("hidden.bs.dropdown",f)))))}))}function d(b){return this.each(function(){var c=a(this),d=c.data("bs.dropdown");d||c.data("bs.dropdown",d=new g(this)),"string"==typeof b&&d[b].call(c)})}var e=".dropdown-backdrop",f='[data-toggle="dropdown"]',g=function(b){a(b).on("click.bs.dropdown",this.toggle)};g.VERSION="3.3.7",g.prototype.toggle=function(d){var e=a(this);if(!e.is(".disabled, :disabled")){var f=b(e),g=f.hasClass("open");if(c(),!g){"ontouchstart"in document.documentElement&&!f.closest(".navbar-nav").length&&a(document.createElement("div")).addClass("dropdown-backdrop").insertAfter(a(this)).on("click",c);var h={relatedTarget:this};if(f.trigger(d=a.Event("show.bs.dropdown",h)),d.isDefaultPrevented())return;e.trigger("focus").attr("aria-expanded","true"),f.toggleClass("open").trigger(a.Event("shown.bs.dropdown",h))}return!1}},g.prototype.keydown=function(c){if(/(38|40|27|32)/.test(c.which)&&!/input|textarea/i.test(c.target.tagName)){var d=a(this);if(c.preventDefault(),c.stopPropagation(),!d.is(".disabled, :disabled")){var e=b(d),g=e.hasClass("open");if(!g&&27!=c.which||g&&27==c.which)return 27==c.which&&e.find(f).trigger("focus"),d.trigger("click");var h=" li:not(.disabled):visible a",i=e.find(".dropdown-menu"+h);if(i.length){var j=i.index(c.target);38==c.which&&j>0&&j--,40==c.which&&j<i.length-1&&j++,~j||(j=0),i.eq(j).trigger("focus")}}}};var h=a.fn.dropdown;a.fn.dropdown=d,a.fn.dropdown.Constructor=g,a.fn.dropdown.noConflict=function(){return a.fn.dropdown=h,this},a(document).on("click.bs.dropdown.data-api",c).on("click.bs.dropdown.data-api",".dropdown form",function(a){a.stopPropagation()}).on("click.bs.dropdown.data-api",f,g.prototype.toggle).on("keydown.bs.dropdown.data-api",f,g.prototype.keydown).on("keydown.bs.dropdown.data-api",".dropdown-menu",g.prototype.keydown)}(jQuery),+function(a){"use strict";function b(b,d){return this.each(function(){var e=a(this),f=e.data("bs.modal"),g=a.extend({},c.DEFAULTS,e.data(),"object"==typeof b&&b);f||e.data("bs.modal",f=new c(this,g)),"string"==typeof b?f[b](d):g.show&&f.show(d)})}var c=function(b,c){this.options=c,this.$body=a(document.body),this.$element=a(b),this.$dialog=this.$element.find(".modal-dialog"),this.$backdrop=null,this.isShown=null,this.originalBodyPad=null,this.scrollbarWidth=0,this.ignoreBackdropClick=!1,this.options.remote&&this.$element.find(".modal-content").load(this.options.remote,a.proxy(function(){this.$element.trigger("loaded.bs.modal")},this))};c.VERSION="3.3.7",c.TRANSITION_DURATION=300,c.BACKDROP_TRANSITION_DURATION=150,c.DEFAULTS={backdrop:!0,keyboard:!0,show:!0},c.prototype.toggle=function(a){return this.isShown?this.hide():this.show(a)},c.prototype.show=function(b){var d=this,e=a.Event("show.bs.modal",{relatedTarget:b});this.$element.trigger(e),this.isShown||e.isDefaultPrevented()||(this.isShown=!0,this.checkScrollbar(),this.setScrollbar(),this.$body.addClass("modal-open"),this.escape(),this.resize(),this.$element.on("click.dismiss.bs.modal",'[data-dismiss="modal"]',a.proxy(this.hide,this)),this.$dialog.on("mousedown.dismiss.bs.modal",function(){d.$element.one("mouseup.dismiss.bs.modal",function(b){a(b.target).is(d.$element)&&(d.ignoreBackdropClick=!0)})}),this.backdrop(function(){var e=a.support.transition&&d.$element.hasClass("fade");d.$element.parent().length||d.$element.appendTo(d.$body),d.$element.show().scrollTop(0),d.adjustDialog(),e&&d.$element[0].offsetWidth,d.$element.addClass("in"),d.enforceFocus();var f=a.Event("shown.bs.modal",{relatedTarget:b});e?d.$dialog.one("bsTransitionEnd",function(){d.$element.trigger("focus").trigger(f)}).emulateTransitionEnd(c.TRANSITION_DURATION):d.$element.trigger("focus").trigger(f)}))},c.prototype.hide=function(b){b&&b.preventDefault(),b=a.Event("hide.bs.modal"),this.$element.trigger(b),this.isShown&&!b.isDefaultPrevented()&&(this.isShown=!1,this.escape(),this.resize(),a(document).off("focusin.bs.modal"),this.$element.removeClass("in").off("click.dismiss.bs.modal").off("mouseup.dismiss.bs.modal"),this.$dialog.off("mousedown.dismiss.bs.modal"),a.support.transition&&this.$element.hasClass("fade")?this.$element.one("bsTransitionEnd",a.proxy(this.hideModal,this)).emulateTransitionEnd(c.TRANSITION_DURATION):this.hideModal())},c.prototype.enforceFocus=function(){a(document).off("focusin.bs.modal").on("focusin.bs.modal",a.proxy(function(a){document===a.target||this.$element[0]===a.target||this.$element.has(a.target).length||this.$element.trigger("focus")},this))},c.prototype.escape=function(){this.isShown&&this.options.keyboard?this.$element.on("keydown.dismiss.bs.modal",a.proxy(function(a){27==a.which&&this.hide()},this)):this.isShown||this.$element.off("keydown.dismiss.bs.modal")},c.prototype.resize=function(){this.isShown?a(window).on("resize.bs.modal",a.proxy(this.handleUpdate,this)):a(window).off("resize.bs.modal")},c.prototype.hideModal=function(){var a=this;this.$element.hide(),this.backdrop(function(){a.$body.removeClass("modal-open"),a.resetAdjustments(),a.resetScrollbar(),a.$element.trigger("hidden.bs.modal")})},c.prototype.removeBackdrop=function(){this.$backdrop&&this.$backdrop.remove(),this.$backdrop=null},c.prototype.backdrop=function(b){var d=this,e=this.$element.hasClass("fade")?"fade":"";if(this.isShown&&this.options.backdrop){var f=a.support.transition&&e;if(this.$backdrop=a(document.createElement("div")).addClass("modal-backdrop "+e).appendTo(this.$body),this.$element.on("click.dismiss.bs.modal",a.proxy(function(a){return this.ignoreBackdropClick?void(this.ignoreBackdropClick=!1):void(a.target===a.currentTarget&&("static"==this.options.backdrop?this.$element[0].focus():this.hide()))},this)),f&&this.$backdrop[0].offsetWidth,this.$backdrop.addClass("in"),!b)return;f?this.$backdrop.one("bsTransitionEnd",b).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION):b()}else if(!this.isShown&&this.$backdrop){this.$backdrop.removeClass("in");var g=function(){d.removeBackdrop(),b&&b()};a.support.transition&&this.$element.hasClass("fade")?this.$backdrop.one("bsTransitionEnd",g).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION):g()}else b&&b()},c.prototype.handleUpdate=function(){this.adjustDialog()},c.prototype.adjustDialog=function(){var a=this.$element[0].scrollHeight>document.documentElement.clientHeight;this.$element.css({paddingLeft:!this.bodyIsOverflowing&&a?this.scrollbarWidth:"",paddingRight:this.bodyIsOverflowing&&!a?this.scrollbarWidth:""})},c.prototype.resetAdjustments=function(){this.$element.css({paddingLeft:"",paddingRight:""})},c.prototype.checkScrollbar=function(){var a=window.innerWidth;if(!a){var b=document.documentElement.getBoundingClientRect();a=b.right-Math.abs(b.left)}this.bodyIsOverflowing=document.body.clientWidth<a,this.scrollbarWidth=this.measureScrollbar()},c.prototype.setScrollbar=function(){var a=parseInt(this.$body.css("padding-right")||0,10);this.originalBodyPad=document.body.style.paddingRight||"",this.bodyIsOverflowing&&this.$body.css("padding-right",a+this.scrollbarWidth)},c.prototype.resetScrollbar=function(){this.$body.css("padding-right",this.originalBodyPad)},c.prototype.measureScrollbar=function(){var a=document.createElement("div");a.className="modal-scrollbar-measure",this.$body.append(a);var b=a.offsetWidth-a.clientWidth;return this.$body[0].removeChild(a),b};var d=a.fn.modal;a.fn.modal=b,a.fn.modal.Constructor=c,a.fn.modal.noConflict=function(){return a.fn.modal=d,this},a(document).on("click.bs.modal.data-api",'[data-toggle="modal"]',function(c){var d=a(this),e=d.attr("href"),f=a(d.attr("data-target")||e&&e.replace(/.*(?=#[^\s]+$)/,"")),g=f.data("bs.modal")?"toggle":a.extend({remote:!/#/.test(e)&&e},f.data(),d.data());d.is("a")&&c.preventDefault(),f.one("show.bs.modal",function(a){a.isDefaultPrevented()||f.one("hidden.bs.modal",function(){d.is(":visible")&&d.trigger("focus")})}),b.call(f,g,this)})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.tooltip"),f="object"==typeof b&&b;!e&&/destroy|hide/.test(b)||(e||d.data("bs.tooltip",e=new c(this,f)),"string"==typeof b&&e[b]())})}var c=function(a,b){this.type=null,this.options=null,this.enabled=null,this.timeout=null,this.hoverState=null,this.$element=null,this.inState=null,this.init("tooltip",a,b)};c.VERSION="3.3.7",c.TRANSITION_DURATION=150,c.DEFAULTS={animation:!0,placement:"top",selector:!1,template:'<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',trigger:"hover focus",title:"",delay:0,html:!1,container:!1,viewport:{selector:"body",padding:0}},c.prototype.init=function(b,c,d){if(this.enabled=!0,this.type=b,this.$element=a(c),this.options=this.getOptions(d),this.$viewport=this.options.viewport&&a(a.isFunction(this.options.viewport)?this.options.viewport.call(this,this.$element):this.options.viewport.selector||this.options.viewport),this.inState={click:!1,hover:!1,focus:!1},this.$element[0]instanceof document.constructor&&!this.options.selector)throw new Error("`selector` option must be specified when initializing "+this.type+" on the window.document object!");for(var e=this.options.trigger.split(" "),f=e.length;f--;){var g=e[f];if("click"==g)this.$element.on("click."+this.type,this.options.selector,a.proxy(this.toggle,this));else if("manual"!=g){var h="hover"==g?"mouseenter":"focusin",i="hover"==g?"mouseleave":"focusout";this.$element.on(h+"."+this.type,this.options.selector,a.proxy(this.enter,this)),this.$element.on(i+"."+this.type,this.options.selector,a.proxy(this.leave,this))}}this.options.selector?this._options=a.extend({},this.options,{trigger:"manual",selector:""}):this.fixTitle()},c.prototype.getDefaults=function(){return c.DEFAULTS},c.prototype.getOptions=function(b){return b=a.extend({},this.getDefaults(),this.$element.data(),b),b.delay&&"number"==typeof b.delay&&(b.delay={show:b.delay,hide:b.delay}),b},c.prototype.getDelegateOptions=function(){var b={},c=this.getDefaults();return this._options&&a.each(this._options,function(a,d){c[a]!=d&&(b[a]=d)}),b},c.prototype.enter=function(b){var c=b instanceof this.constructor?b:a(b.currentTarget).data("bs."+this.type);return c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c)),b instanceof a.Event&&(c.inState["focusin"==b.type?"focus":"hover"]=!0),c.tip().hasClass("in")||"in"==c.hoverState?void(c.hoverState="in"):(clearTimeout(c.timeout),c.hoverState="in",c.options.delay&&c.options.delay.show?void(c.timeout=setTimeout(function(){"in"==c.hoverState&&c.show()},c.options.delay.show)):c.show())},c.prototype.isInStateTrue=function(){for(var a in this.inState)if(this.inState[a])return!0;return!1},c.prototype.leave=function(b){var c=b instanceof this.constructor?b:a(b.currentTarget).data("bs."+this.type);if(c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c)),b instanceof a.Event&&(c.inState["focusout"==b.type?"focus":"hover"]=!1),!c.isInStateTrue())return clearTimeout(c.timeout),c.hoverState="out",c.options.delay&&c.options.delay.hide?void(c.timeout=setTimeout(function(){"out"==c.hoverState&&c.hide()},c.options.delay.hide)):c.hide()},c.prototype.show=function(){var b=a.Event("show.bs."+this.type);if(this.hasContent()&&this.enabled){this.$element.trigger(b);var d=a.contains(this.$element[0].ownerDocument.documentElement,this.$element[0]);if(b.isDefaultPrevented()||!d)return;var e=this,f=this.tip(),g=this.getUID(this.type);this.setContent(),f.attr("id",g),this.$element.attr("aria-describedby",g),this.options.animation&&f.addClass("fade");var h="function"==typeof this.options.placement?this.options.placement.call(this,f[0],this.$element[0]):this.options.placement,i=/\s?auto?\s?/i,j=i.test(h);j&&(h=h.replace(i,"")||"top"),f.detach().css({top:0,left:0,display:"block"}).addClass(h).data("bs."+this.type,this),this.options.container?f.appendTo(this.options.container):f.insertAfter(this.$element),this.$element.trigger("inserted.bs."+this.type);var k=this.getPosition(),l=f[0].offsetWidth,m=f[0].offsetHeight;if(j){var n=h,o=this.getPosition(this.$viewport);h="bottom"==h&&k.bottom+m>o.bottom?"top":"top"==h&&k.top-m<o.top?"bottom":"right"==h&&k.right+l>o.width?"left":"left"==h&&k.left-l<o.left?"right":h,f.removeClass(n).addClass(h)}var p=this.getCalculatedOffset(h,k,l,m);this.applyPlacement(p,h);var q=function(){var a=e.hoverState;e.$element.trigger("shown.bs."+e.type),e.hoverState=null,"out"==a&&e.leave(e)};a.support.transition&&this.$tip.hasClass("fade")?f.one("bsTransitionEnd",q).emulateTransitionEnd(c.TRANSITION_DURATION):q()}},c.prototype.applyPlacement=function(b,c){var d=this.tip(),e=d[0].offsetWidth,f=d[0].offsetHeight,g=parseInt(d.css("margin-top"),10),h=parseInt(d.css("margin-left"),10);isNaN(g)&&(g=0),isNaN(h)&&(h=0),b.top+=g,b.left+=h,a.offset.setOffset(d[0],a.extend({using:function(a){d.css({top:Math.round(a.top),left:Math.round(a.left)})}},b),0),d.addClass("in");var i=d[0].offsetWidth,j=d[0].offsetHeight;"top"==c&&j!=f&&(b.top=b.top+f-j);var k=this.getViewportAdjustedDelta(c,b,i,j);k.left?b.left+=k.left:b.top+=k.top;var l=/top|bottom/.test(c),m=l?2*k.left-e+i:2*k.top-f+j,n=l?"offsetWidth":"offsetHeight";d.offset(b),this.replaceArrow(m,d[0][n],l)},c.prototype.replaceArrow=function(a,b,c){this.arrow().css(c?"left":"top",50*(1-a/b)+"%").css(c?"top":"left","")},c.prototype.setContent=function(){var a=this.tip(),b=this.getTitle();a.find(".tooltip-inner")[this.options.html?"html":"text"](b),a.removeClass("fade in top bottom left right")},c.prototype.hide=function(b){function d(){"in"!=e.hoverState&&f.detach(),e.$element&&e.$element.removeAttr("aria-describedby").trigger("hidden.bs."+e.type),b&&b()}var e=this,f=a(this.$tip),g=a.Event("hide.bs."+this.type);if(this.$element.trigger(g),!g.isDefaultPrevented())return f.removeClass("in"),a.support.transition&&f.hasClass("fade")?f.one("bsTransitionEnd",d).emulateTransitionEnd(c.TRANSITION_DURATION):d(),this.hoverState=null,this},c.prototype.fixTitle=function(){var a=this.$element;(a.attr("title")||"string"!=typeof a.attr("data-original-title"))&&a.attr("data-original-title",a.attr("title")||"").attr("title","")},c.prototype.hasContent=function(){return this.getTitle()},c.prototype.getPosition=function(b){b=b||this.$element;var c=b[0],d="BODY"==c.tagName,e=c.getBoundingClientRect();null==e.width&&(e=a.extend({},e,{width:e.right-e.left,height:e.bottom-e.top}));var f=window.SVGElement&&c instanceof window.SVGElement,g=d?{top:0,left:0}:f?null:b.offset(),h={scroll:d?document.documentElement.scrollTop||document.body.scrollTop:b.scrollTop()},i=d?{width:a(window).width(),height:a(window).height()}:null;return a.extend({},e,h,i,g)},c.prototype.getCalculatedOffset=function(a,b,c,d){return"bottom"==a?{top:b.top+b.height,left:b.left+b.width/2-c/2}:"top"==a?{top:b.top-d,left:b.left+b.width/2-c/2}:"left"==a?{top:b.top+b.height/2-d/2,left:b.left-c}:{top:b.top+b.height/2-d/2,left:b.left+b.width}},c.prototype.getViewportAdjustedDelta=function(a,b,c,d){var e={top:0,left:0};if(!this.$viewport)return e;var f=this.options.viewport&&this.options.viewport.padding||0,g=this.getPosition(this.$viewport);if(/right|left/.test(a)){var h=b.top-f-g.scroll,i=b.top+f-g.scroll+d;h<g.top?e.top=g.top-h:i>g.top+g.height&&(e.top=g.top+g.height-i)}else{var j=b.left-f,k=b.left+f+c;j<g.left?e.left=g.left-j:k>g.right&&(e.left=g.left+g.width-k)}return e},c.prototype.getTitle=function(){var a,b=this.$element,c=this.options;return a=b.attr("data-original-title")||("function"==typeof c.title?c.title.call(b[0]):c.title)},c.prototype.getUID=function(a){do a+=~~(1e6*Math.random());while(document.getElementById(a));return a},c.prototype.tip=function(){if(!this.$tip&&(this.$tip=a(this.options.template),1!=this.$tip.length))throw new Error(this.type+" `template` option must consist of exactly 1 top-level element!");return this.$tip},c.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".tooltip-arrow")},c.prototype.enable=function(){this.enabled=!0},c.prototype.disable=function(){this.enabled=!1},c.prototype.toggleEnabled=function(){this.enabled=!this.enabled},c.prototype.toggle=function(b){var c=this;b&&(c=a(b.currentTarget).data("bs."+this.type),c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c))),b?(c.inState.click=!c.inState.click,c.isInStateTrue()?c.enter(c):c.leave(c)):c.tip().hasClass("in")?c.leave(c):c.enter(c)},c.prototype.destroy=function(){var a=this;clearTimeout(this.timeout),this.hide(function(){a.$element.off("."+a.type).removeData("bs."+a.type),a.$tip&&a.$tip.detach(),a.$tip=null,a.$arrow=null,a.$viewport=null,a.$element=null})};var d=a.fn.tooltip;a.fn.tooltip=b,a.fn.tooltip.Constructor=c,a.fn.tooltip.noConflict=function(){return a.fn.tooltip=d,this}}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.popover"),f="object"==typeof b&&b;!e&&/destroy|hide/.test(b)||(e||d.data("bs.popover",e=new c(this,f)),"string"==typeof b&&e[b]())})}var c=function(a,b){this.init("popover",a,b)};if(!a.fn.tooltip)throw new Error("Popover requires tooltip.js");c.VERSION="3.3.7",c.DEFAULTS=a.extend({},a.fn.tooltip.Constructor.DEFAULTS,{placement:"right",trigger:"click",content:"",template:'<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'}),c.prototype=a.extend({},a.fn.tooltip.Constructor.prototype),c.prototype.constructor=c,c.prototype.getDefaults=function(){return c.DEFAULTS},c.prototype.setContent=function(){var a=this.tip(),b=this.getTitle(),c=this.getContent();a.find(".popover-title")[this.options.html?"html":"text"](b),a.find(".popover-content").children().detach().end()[this.options.html?"string"==typeof c?"html":"append":"text"](c),a.removeClass("fade top bottom left right in"),a.find(".popover-title").html()||a.find(".popover-title").hide()},c.prototype.hasContent=function(){return this.getTitle()||this.getContent()},c.prototype.getContent=function(){var a=this.$element,b=this.options;return a.attr("data-content")||("function"==typeof b.content?b.content.call(a[0]):b.content)},c.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".arrow")};var d=a.fn.popover;a.fn.popover=b,a.fn.popover.Constructor=c,a.fn.popover.noConflict=function(){return a.fn.popover=d,this}}(jQuery),+function(a){"use strict";function b(c,d){this.$body=a(document.body),this.$scrollElement=a(a(c).is(document.body)?window:c),this.options=a.extend({},b.DEFAULTS,d),this.selector=(this.options.target||"")+" .nav li > a",this.offsets=[],this.targets=[],this.activeTarget=null,this.scrollHeight=0,this.$scrollElement.on("scroll.bs.scrollspy",a.proxy(this.process,this)),this.refresh(),this.process()}function c(c){return this.each(function(){var d=a(this),e=d.data("bs.scrollspy"),f="object"==typeof c&&c;e||d.data("bs.scrollspy",e=new b(this,f)),"string"==typeof c&&e[c]()})}b.VERSION="3.3.7",b.DEFAULTS={offset:10},b.prototype.getScrollHeight=function(){return this.$scrollElement[0].scrollHeight||Math.max(this.$body[0].scrollHeight,document.documentElement.scrollHeight)},b.prototype.refresh=function(){var b=this,c="offset",d=0;this.offsets=[],this.targets=[],this.scrollHeight=this.getScrollHeight(),a.isWindow(this.$scrollElement[0])||(c="position",d=this.$scrollElement.scrollTop()),this.$body.find(this.selector).map(function(){var b=a(this),e=b.data("target")||b.attr("href"),f=/^#./.test(e)&&a(e);return f&&f.length&&f.is(":visible")&&[[f[c]().top+d,e]]||null}).sort(function(a,b){return a[0]-b[0]}).each(function(){b.offsets.push(this[0]),b.targets.push(this[1])})},b.prototype.process=function(){var a,b=this.$scrollElement.scrollTop()+this.options.offset,c=this.getScrollHeight(),d=this.options.offset+c-this.$scrollElement.height(),e=this.offsets,f=this.targets,g=this.activeTarget;if(this.scrollHeight!=c&&this.refresh(),b>=d)return g!=(a=f[f.length-1])&&this.activate(a);if(g&&b<e[0])return this.activeTarget=null,this.clear();for(a=e.length;a--;)g!=f[a]&&b>=e[a]&&(void 0===e[a+1]||b<e[a+1])&&this.activate(f[a])},b.prototype.activate=function(b){
this.activeTarget=b,this.clear();var c=this.selector+'[data-target="'+b+'"],'+this.selector+'[href="'+b+'"]',d=a(c).parents("li").addClass("active");d.parent(".dropdown-menu").length&&(d=d.closest("li.dropdown").addClass("active")),d.trigger("activate.bs.scrollspy")},b.prototype.clear=function(){a(this.selector).parentsUntil(this.options.target,".active").removeClass("active")};var d=a.fn.scrollspy;a.fn.scrollspy=c,a.fn.scrollspy.Constructor=b,a.fn.scrollspy.noConflict=function(){return a.fn.scrollspy=d,this},a(window).on("load.bs.scrollspy.data-api",function(){a('[data-spy="scroll"]').each(function(){var b=a(this);c.call(b,b.data())})})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.tab");e||d.data("bs.tab",e=new c(this)),"string"==typeof b&&e[b]()})}var c=function(b){this.element=a(b)};c.VERSION="3.3.7",c.TRANSITION_DURATION=150,c.prototype.show=function(){var b=this.element,c=b.closest("ul:not(.dropdown-menu)"),d=b.data("target");if(d||(d=b.attr("href"),d=d&&d.replace(/.*(?=#[^\s]*$)/,"")),!b.parent("li").hasClass("active")){var e=c.find(".active:last a"),f=a.Event("hide.bs.tab",{relatedTarget:b[0]}),g=a.Event("show.bs.tab",{relatedTarget:e[0]});if(e.trigger(f),b.trigger(g),!g.isDefaultPrevented()&&!f.isDefaultPrevented()){var h=a(d);this.activate(b.closest("li"),c),this.activate(h,h.parent(),function(){e.trigger({type:"hidden.bs.tab",relatedTarget:b[0]}),b.trigger({type:"shown.bs.tab",relatedTarget:e[0]})})}}},c.prototype.activate=function(b,d,e){function f(){g.removeClass("active").find("> .dropdown-menu > .active").removeClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded",!1),b.addClass("active").find('[data-toggle="tab"]').attr("aria-expanded",!0),h?(b[0].offsetWidth,b.addClass("in")):b.removeClass("fade"),b.parent(".dropdown-menu").length&&b.closest("li.dropdown").addClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded",!0),e&&e()}var g=d.find("> .active"),h=e&&a.support.transition&&(g.length&&g.hasClass("fade")||!!d.find("> .fade").length);g.length&&h?g.one("bsTransitionEnd",f).emulateTransitionEnd(c.TRANSITION_DURATION):f(),g.removeClass("in")};var d=a.fn.tab;a.fn.tab=b,a.fn.tab.Constructor=c,a.fn.tab.noConflict=function(){return a.fn.tab=d,this};var e=function(c){c.preventDefault(),b.call(a(this),"show")};a(document).on("click.bs.tab.data-api",'[data-toggle="tab"]',e).on("click.bs.tab.data-api",'[data-toggle="pill"]',e)}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.affix"),f="object"==typeof b&&b;e||d.data("bs.affix",e=new c(this,f)),"string"==typeof b&&e[b]()})}var c=function(b,d){this.options=a.extend({},c.DEFAULTS,d),this.$target=a(this.options.target).on("scroll.bs.affix.data-api",a.proxy(this.checkPosition,this)).on("click.bs.affix.data-api",a.proxy(this.checkPositionWithEventLoop,this)),this.$element=a(b),this.affixed=null,this.unpin=null,this.pinnedOffset=null,this.checkPosition()};c.VERSION="3.3.7",c.RESET="affix affix-top affix-bottom",c.DEFAULTS={offset:0,target:window},c.prototype.getState=function(a,b,c,d){var e=this.$target.scrollTop(),f=this.$element.offset(),g=this.$target.height();if(null!=c&&"top"==this.affixed)return e<c&&"top";if("bottom"==this.affixed)return null!=c?!(e+this.unpin<=f.top)&&"bottom":!(e+g<=a-d)&&"bottom";var h=null==this.affixed,i=h?e:f.top,j=h?g:b;return null!=c&&e<=c?"top":null!=d&&i+j>=a-d&&"bottom"},c.prototype.getPinnedOffset=function(){if(this.pinnedOffset)return this.pinnedOffset;this.$element.removeClass(c.RESET).addClass("affix");var a=this.$target.scrollTop(),b=this.$element.offset();return this.pinnedOffset=b.top-a},c.prototype.checkPositionWithEventLoop=function(){setTimeout(a.proxy(this.checkPosition,this),1)},c.prototype.checkPosition=function(){if(this.$element.is(":visible")){var b=this.$element.height(),d=this.options.offset,e=d.top,f=d.bottom,g=Math.max(a(document).height(),a(document.body).height());"object"!=typeof d&&(f=e=d),"function"==typeof e&&(e=d.top(this.$element)),"function"==typeof f&&(f=d.bottom(this.$element));var h=this.getState(g,b,e,f);if(this.affixed!=h){null!=this.unpin&&this.$element.css("top","");var i="affix"+(h?"-"+h:""),j=a.Event(i+".bs.affix");if(this.$element.trigger(j),j.isDefaultPrevented())return;this.affixed=h,this.unpin="bottom"==h?this.getPinnedOffset():null,this.$element.removeClass(c.RESET).addClass(i).trigger(i.replace("affix","affixed")+".bs.affix")}"bottom"==h&&this.$element.offset({top:g-b-f})}};var d=a.fn.affix;a.fn.affix=b,a.fn.affix.Constructor=c,a.fn.affix.noConflict=function(){return a.fn.affix=d,this},a(window).on("load",function(){a('[data-spy="affix"]').each(function(){var c=a(this),d=c.data();d.offset=d.offset||{},null!=d.offsetBottom&&(d.offset.bottom=d.offsetBottom),null!=d.offsetTop&&(d.offset.top=d.offsetTop),b.call(c,d)})})}(jQuery);
/*!
 * JavaScript Cookie v2.1.4
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader = false;
	if (typeof define === 'function' && define.amd) {
		define(factory);
		registeredInModuleLoader = true;
	}
	if (typeof exports === 'object') {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function init (converter) {
		function api (key, value, attributes) {
			var result;
			if (typeof document === 'undefined') {
				return;
			}

			// Write

			if (arguments.length > 1) {
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);

				if (typeof attributes.expires === 'number') {
					var expires = new Date();
					expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
					attributes.expires = expires;
				}

				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

				try {
					result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}

				if (!converter.write) {
					value = encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
				} else {
					value = converter.write(value, key);
				}

				key = encodeURIComponent(String(key));
				key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
				key = key.replace(/[\(\)]/g, escape);

				var stringifiedAttributes = '';

				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
					stringifiedAttributes += '=' + attributes[attributeName];
				}
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}

			// Read

			if (!key) {
				result = {};
			}

			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all. Also prevents odd result when
			// calling "get()"
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var rdecode = /(%[0-9A-Z]{2})+/g;
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = parts[0].replace(rdecode, decodeURIComponent);
					cookie = converter.read ?
						converter.read(cookie, name) : converter(cookie, name) ||
						cookie.replace(rdecode, decodeURIComponent);

					if (this.json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					if (key === name) {
						result = cookie;
						break;
					}

					if (!key) {
						result[name] = cookie;
					}
				} catch (e) {}
			}

			return result;
		}

		api.set = api;
		api.get = function (key) {
			return api.call(api, key);
		};
		api.getJSON = function () {
			return api.apply({
				json: true
			}, [].slice.call(arguments));
		};
		api.defaults = {};

		api.remove = function (key, attributes) {
			api(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));
function _extends(){return(_extends=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t}).apply(this,arguments)}function _typeof(t){return(_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}!function(t,e){"object"===("undefined"==typeof exports?"undefined":_typeof(exports))&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):t.LazyLoad=e()}(this,function(){"use strict";var t="undefined"!=typeof window,e=t&&!("onscroll"in window)||"undefined"!=typeof navigator&&/(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent),n=t&&"IntersectionObserver"in window,o=t&&"classList"in document.createElement("p"),r={elements_selector:"img",container:e||t?document:null,threshold:300,thresholds:null,data_src:"src",data_srcset:"srcset",data_sizes:"sizes",data_bg:"bg",class_loading:"loading",class_loaded:"loaded",class_error:"error",load_delay:0,auto_unobserve:!0,callback_enter:null,callback_exit:null,callback_reveal:null,callback_loaded:null,callback_error:null,callback_finish:null},a=function(t,e){return t.getAttribute("data-"+e)},s=function(t,e,n){var o="data-"+e;null!==n?t.setAttribute(o,n):t.removeAttribute(o)},i=function(t){return"true"===a(t,"was-processed")},c=function(t,e){return s(t,"ll-timeout",e)},l=function(t){return a(t,"ll-timeout")},u=function(t,e){var n,o=new t(e);try{n=new CustomEvent("LazyLoad::Initialized",{detail:{instance:o}})}catch(t){(n=document.createEvent("CustomEvent")).initCustomEvent("LazyLoad::Initialized",!1,!1,{instance:o})}window.dispatchEvent(n)};var d=function(t,e){t&&t(e)},f=function(t,e){t._loadingCount+=e,0===t._elements.length&&0===t._loadingCount&&d(t._settings.callback_finish)},_=function(t){for(var e,n=[],o=0;e=t.children[o];o+=1)"SOURCE"===e.tagName&&n.push(e);return n},v=function(t,e,n){n&&t.setAttribute(e,n)},g=function(t,e){v(t,"sizes",a(t,e.data_sizes)),v(t,"srcset",a(t,e.data_srcset)),v(t,"src",a(t,e.data_src))},b={IMG:function(t,e){var n=t.parentNode;n&&"PICTURE"===n.tagName&&_(n).forEach(function(t){g(t,e)});g(t,e)},IFRAME:function(t,e){v(t,"src",a(t,e.data_src))},VIDEO:function(t,e){_(t).forEach(function(t){v(t,"src",a(t,e.data_src))}),v(t,"src",a(t,e.data_src)),t.load()}},m=function(t,e){var n,o,r=e._settings,s=t.tagName,i=b[s];if(i)return i(t,r),f(e,1),void(e._elements=(n=e._elements,o=t,n.filter(function(t){return t!==o})));!function(t,e){var n=a(t,e.data_src),o=a(t,e.data_bg);n&&(t.style.backgroundImage='url("'.concat(n,'")')),o&&(t.style.backgroundImage=o)}(t,r)},h=function(t,e){o?t.classList.add(e):t.className+=(t.className?" ":"")+e},p=function(t,e,n){t.addEventListener(e,n)},y=function(t,e,n){t.removeEventListener(e,n)},E=function(t,e,n){y(t,"load",e),y(t,"loadeddata",e),y(t,"error",n)},w=function(t,e,n){var r=n._settings,a=e?r.class_loaded:r.class_error,s=e?r.callback_loaded:r.callback_error,i=t.target;!function(t,e){o?t.classList.remove(e):t.className=t.className.replace(new RegExp("(^|\\s+)"+e+"(\\s+|$)")," ").replace(/^\s+/,"").replace(/\s+$/,"")}(i,r.class_loading),h(i,a),d(s,i),f(n,-1)},k=function(t,e){var n=function n(r){w(r,!0,e),E(t,n,o)},o=function o(r){w(r,!1,e),E(t,n,o)};!function(t,e,n){p(t,"load",e),p(t,"loadeddata",e),p(t,"error",n)}(t,n,o)},I=["IMG","IFRAME","VIDEO"],L=function(t,e){var n=e._observer;z(t,e),n&&e._settings.auto_unobserve&&n.unobserve(t)},x=function(t){var e=l(t);e&&(clearTimeout(e),c(t,null))},A=function(t,e){var n=e._settings.load_delay,o=l(t);o||(o=setTimeout(function(){L(t,e),x(t)},n),c(t,o))},z=function(t,e,n){var o=e._settings;!n&&i(t)||(I.indexOf(t.tagName)>-1&&(k(t,e),h(t,o.class_loading)),m(t,e),function(t){s(t,"was-processed","true")}(t),d(o.callback_reveal,t))},O=function(t){return!!n&&(t._observer=new IntersectionObserver(function(e){e.forEach(function(e){return function(t){return t.isIntersecting||t.intersectionRatio>0}(e)?function(t,e){var n=e._settings;d(n.callback_enter,t),n.load_delay?A(t,e):L(t,e)}(e.target,t):function(t,e){var n=e._settings;d(n.callback_exit,t),n.load_delay&&x(t)}(e.target,t)})},{root:(e=t._settings).container===document?null:e.container,rootMargin:e.thresholds||e.threshold+"px"}),!0);var e},N=function(t,e){this._settings=function(t){return _extends({},r,t)}(t),this._loadingCount=0,O(this),this.update(e)};return N.prototype={update:function(t){var n=this,o=this._settings,r=t||o.container.querySelectorAll(o.elements_selector);this._elements=function(t){return t.filter(function(t){return!i(t)})}(Array.prototype.slice.call(r)),!e&&this._observer?this._elements.forEach(function(t){n._observer.observe(t)}):this.loadAll()},destroy:function(){var t=this;this._observer&&(this._elements.forEach(function(e){t._observer.unobserve(e)}),this._observer=null),this._elements=null,this._settings=null},load:function(t,e){z(t,this,e)},loadAll:function(){var t=this;this._elements.forEach(function(e){L(e,t)})}},t&&function(t,e){if(e)if(e.length)for(var n,o=0;n=e[o];o+=1)u(t,n);else u(t,e)}(N,window.lazyLoadOptions),N});
//# sourceMappingURL=lazyload.min.js.map

class tireSize {
    static regex() {
        return /(\d{2}5)\s*[/\-x]?\s*(\d[05])\s*[/\-x]?\s*(R|r)?\s*(\d{2})/;
    }

    static buildFormat(breedte, hoogte, inch) {
        inch = inch.toString().toLowerCase().replace("r", "");

        return breedte + " / " + hoogte + " R" + inch;
    }

    static setData(breedte, hoogte, inch) {
        var text = this.buildFormat(breedte, hoogte, inch);
        this.set(text);
    }

    static set(size) {
        Cookies2.set("tireSize", size, { expires: 365, path: "/" });
    }

    static getForAPI() {
        var sizeData = this.parse();

        return `${sizeData[0]}/${sizeData[1]} R${sizeData[2]}`;
    }

    static get() {
        return Cookies2.get("tireSize") || false;
    }

    static getDefault() {
        return [205, 55, 16];
    }

    static parse(size = false) {
        if (size === false) {
            size = this.get();
        }

        if (size === false) return this.getDefault();

        var m;
        var regexFormat = this.regex();
        if ((m = regexFormat.exec(size)) !== null) {
            return [m[1], m[2], m[4]];
        }

        return this.getDefault();
    }

    static modifyHomeSearch(searchData) {
        var selectedSizeData = this.parse();

        var fieldsToExclude = ["breedte", "hoogte", "inch"];

        var searchData = searchData.filter(function (field) {
            return !fieldsToExclude.includes(field.name);
        });

        searchData.push({ name: "breedte", value: selectedSizeData[0] });
        searchData.push({ name: "hoogte", value: selectedSizeData[1] });
        searchData.push({ name: "inch", value: "R" + selectedSizeData[2] });

        return searchData;
    }
}

function getiOSVersion() {
    var userAgent = window.navigator.userAgent;
    var iOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    var version = "";

    if (iOS) {
        if (userAgent.includes("CPU iPhone OS")) {
            version = userAgent.match(/CPU iPhone OS (\d+(_\d+)?)/)[1];
        } else if (userAgent.includes("CPU OS")) {
            version = userAgent.match(/CPU OS (\d+(_\d+)?)/)[1];
        } else if (userAgent.includes("iPad; CPU OS")) {
            version = userAgent.match(/iPad; CPU OS (\d+(_\d+)?)/)[1];
        }
    }

    return version ? parseFloat(version.replace("_", ".")) : null;
}

function getBCBaseURL() {
    return document.body.getAttribute("data-base-url");
}

$ = jQuery;

String.prototype.sprintf = function () {
    var counter = 0;
    var args = arguments;

    return this.replace(/%s/g, function () {
        return args[counter++];
    });
};

async function getReviewCounts() {
    var localReviewData = {};
    var fetchReviews = true;

    if (window.localStorage) {
        localReviewData = window.localStorage.getItem("reviewdata");

        if (localReviewData !== null) {
            localReviewData = JSON.parse(localReviewData);

            if (Date.now() - localReviewData.updatedAt < 3600000) {
                fetchReviews = false;
            }
        }
    }

    if (fetchReviews) {
        // older than 1 hr or not set

        $reviewArea = document.querySelector("[data-review-url]");

        if ($reviewArea === null) return;

        var nonCacheURL = $reviewArea.getAttribute("data-review-url");
        var data = {};

        var response = await fetch(nonCacheURL, {
            method: "GET",
            headers: {
                "Content-Type":
                    "application/x-www-form-urlencoded; charset=UTF-8",
                "accept": "application/json",
            },
        })
            .then((resp) => {
                if (resp.status === 200) {
                    return resp.json();
                } else {
                    return Promise.reject("server");
                }
            })
            .then((dataJson) => {
                data = dataJson;
            })
            .catch((err) => {
                if (err === "server") return;
                console.log(err);
            });

        if (typeof data.s != "undefined") {
            data.updatedAt = Date.now();

            window.localStorage.setItem("reviewdata", JSON.stringify(data));
            if (typeof window.updateReviewCounts != "undefined") {
                try {
                    window.updateReviewCounts();
                } catch (e) {
                    console.error(e);
                }
            }
        }
    }
}

try {
    getReviewCounts();
} catch (e) {
    console.error(e);
}

var afterCartUpdate = function () {
        ventielChange();
    },
    Cookies2 = Cookies.noConflict(),
    productPageSlider;

function bc_guid() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (
            c ^
            (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16)
    );
}

if (typeof Cookies2.get("rp_uid") == "undefined") {
    Cookies2.set("rp_uid", bc_guid(), { expires: 365, path: "/" });
}

window.cartTotalItems = function () {
    var amount = 0;
    var cartCookie = Cookies2.get("bc_cart");

    if (typeof cartCookie == "undefined") {
        return amount;
    }

    try {
        cartCookie = JSON.parse(decodeURIComponent(cartCookie));

        Object.keys(cartCookie).forEach(function (key) {
            amount += parseInt(cartCookie[key].aantal);
        });
    } catch (e) {
        console.log(e);
    }

    if (Number.isInteger) {
        return amount;
    }

    return 0;
};

try {
    var cartItems = cartTotalItems();

    if (cartItems === 1) {
        var $removeMethods = document.querySelectorAll(".removeMethod1Tire");

        if ($removeMethods !== null) {
            $removeMethods.forEach(function ($method) {
                $method.remove();
            });
        }
    }
} catch (e) {
    console.error(e);
}

function removePaymentMethodsSingleTire() {
    if (typeof window.hideSingleTirePaymentMethods === "undefined") {
        return;
    }

    var removeMethods = JSON.parse(window.hideSingleTirePaymentMethods);

    if (removeMethods.length === 0) return;

    removeMethods.forEach((paymentMethodName) => {
        var $references = document.querySelectorAll(
            '[data-payment-method-name="' + paymentMethodName + '"]'
        );

        $references.forEach(($method) => {
            $method.remove();
        });
    });

    var $cartPics = document.querySelectorAll(".cart-payment-icons > ul > li");

    if ($cartPics.length === 1) {
        document.querySelector(".cart-payment-icons").remove();
    }
}

window.removePaymentMethodsSingleTire = function () {
    try {
        removePaymentMethodsSingleTire();
    } catch (e) {
        console.error(e);
    }
};

if (window.cartTotalItems() === 1) {
    try {
        removePaymentMethodsSingleTire();
    } catch (e) {
        console.error(e);
    }
}

if ($("body[data-icl-language-code^='ot_']").length > 0) {
    var faviconEl = document.querySelector("link[data-favicon-light]");

    var mediaQueryFavicon = window.matchMedia("(prefers-color-scheme: dark)");
    mediaQueryFavicon.addEventListener("change", faviconThemeChange);

    function faviconThemeChange(event) {
        if (event.matches) {
            faviconEl.setAttribute(
                "href",
                faviconEl.getAttribute("data-favicon-dark")
            );
        } else {
            faviconEl.setAttribute(
                "href",
                faviconEl.getAttribute("data-favicon-light")
            );
        }
    }

    faviconThemeChange(mediaQueryFavicon);
}

$(document).ready(function () {
    var iosVersion = getiOSVersion();

    if (iosVersion !== null && iosVersion < 16.4) {
        $("body").addClass("ios-below-16");
    }
    var iclLangCode = $("body").attr("data-icl-language-code");

    if (iclLangCode.length > 0) {
        Cookies2.set("_icl_current_language", iclLangCode, {
            expires: 1,
            path: "/",
        });
    }

    var setPCookie = false;

    var psSourceCookie = Cookies2.get("bcpps");
    var psSource = maintransl.sids.s1;

    if (typeof psSourceCookie == "undefined") {
        setPCookie = true;
    } else {
        psSource = psSourceCookie;

        if (psSourceCookie == 9 || psSourceCookie == 69) {
            psSource = maintransl.sids.s1;
            setPCookie = true;
        }
    }

    $(window).on("scroll", function () {
        if ($(window).scrollTop() > 0) {
            $("body").addClass("mobile-sticky-searchbar");
            return;
        }

        $("body").removeClass("mobile-sticky-searchbar");
    });

    if (window.location.href.indexOf("gclid=") > 0) {
        if (window.location.href.indexOf("campaign=shopping") === -1) {
            psSource = maintransl.sids.s4;
            setPCookie = true;
        } else {
            setPCookie = false;
        }

        try {
            var searchParams = new URLSearchParams(window.location.search);
            Cookies2.set("bc_gclid", window.btoa(searchParams.get("gclid")), {
                expires: 365,
                path: "/",
            });
        } catch (e) {
            console.error(e);
        }
    } else if (
        window.location.href.indexOf("utm_source=idealo") > 0 &&
        ($("body").attr("data-icl-language-code") == "pi_de" ||
            $("body").attr("data-icl-language-code") == "ot_de")
    ) {
        psSource = 79;
        setPCookie = true;
    } else if (
        window.location.href.indexOf("utm_medium=vergelijkers") > 0 &&
        ($("body").attr("data-icl-language-code") == "pi_de" ||
            $("body").attr("data-icl-language-code") == "ot_de")
    ) {
        psSource = 72;
        setPCookie = true;
    } else if (
        window.location.href.indexOf("utm_medium=vergelijkers") > 0 &&
        $("body").attr("data-icl-language-code") == "ot_fr"
    ) {
        psSource = maintransl.sids.s2;
        setPCookie = true;
    }

    if (setPCookie) {
        Cookies2.set("bcpps", psSource, { expires: 365, path: "/" });
    }

    var cookieConsent = Cookies2.get("consent");

    if (
        typeof cookieConsent == "undefined" &&
        !window.location.pathname.includes("/helpcenter/")
    ) {
        if (
            typeof window.showCookieBar == "undefined" ||
            window.showCookieBar !== false
        ) {
            $('[data-role="cwall"]').removeClass("hidden").modal("show");
        }
    }

    $(document).on("click", "[data-consent-trigger]", function (e) {
        e.preventDefault();

        var consent = parseInt($(this).attr("data-consent-trigger"));
        Cookies2.set("consent", consent, { expires: 365, path: "/" });

        $('[data-role="cwall"]').modal("hide").addClass("hidden");

        return false;
    });

    var $allVideos = $(
        ".video-container:not(.no-resize) iframe[src^='https://www.youtube-nocookie.com']"
    );

    $(window).on("resize", function () {
        $allVideos.each(function () {
            var $el = $(this);
            var newWidth = $(this).closest(".video-container").width();

            var newHeight = newWidth * (1 / (16 / 9));
            $el.width(newWidth).height(newHeight);
            $(this)
                .closest(".video-container")
                .css("padding-bottom", newHeight);
        });
    });

    function b64_to_utf8(str) {
        return decodeURIComponent(escape(window.atob(str)));
    }

    $("body").on("click touchstart", function (e) {
        $('[data-toggle="popover"]').each(function () {
            //the 'is' for buttons that trigger popups
            //the 'has' for icons within a button that triggers a popup
            if (
                !$(this).is(e.target) &&
                $(this).has(e.target).length === 0 &&
                $(".popover").has(e.target).length === 0
            ) {
                $(this).popover("hide");
            }
        });
    });

    //normal rating stars.

    $(document).on("click", "#laagsteprijspopup", function (event) {
        event.preventDefault();

        $.get($(this).data("href"), function (data) {
            var $prijsModal = $(data).modal("show");
        });

        return false;
    });

    $(document).on(
        "click",
        ".nonclickablekiyoh .new-reviewcount > a",
        function (e) {
            e.preventDefault();
        }
    );

    $(document).on("hidden.bs.modal", "#garantieDiag", function () {
        $(".modal-backdrop").remove();
        $("body").removeClass("modal-open");
    });

    $(document).on("click", "#laagsteprijspopup", function () {
        $(this).closest(".popover").remove();
    });

    $("body").on("hidden.bs.popover", function (e) {
        $(e.target).data("bs.popover").inState = {
            click: false,
            hover: false,
            focus: false,
        };
    });

    $("body").on("shown.bs.popover", function (e) {
        window.updateReviewCounts();
    });

    $("#laagsteprijspopup").on("hidden.bs.modal", function (e) {
        $(".modal-backdrop").remove();
        $("body").removeClass("modal-open");
    });

    if ($(".topDataTable").length) {
        $(".topDataTable").dataTable({
            paging: false,
            searching: false,
            //"columnDefs": [{ "orderable": false, "searchable": false, "targets": 0 }],
            //"bInfo" : false,
            info: false,
        });

        $(".topDataTable .jRate-normal").on("mouseenter", function () {
            $(this).closest("td").find(".ratingDetails").show();
        });

        $(".topDataTable .jRate-normal").on("mouseleave", function () {
            $(this).closest("td").find(".ratingDetails").hide();
        });
    }

    $('[data-toggle="tooltip"]').tooltip({
        html: true,
    });

    $(".clickable-row[data-href]").on("click", function () {
        window.document.location = $(this).data("href");
    });

    var browserLanguage = navigator.language || navigator.userLanguage;

    if (
        browserLanguage.toLowerCase() == "nl-be" &&
        window.location.hostname.indexOf("bandenconcurrent") > -1
    ) {
        var beRedirectCookie = Cookies2.get("belg_redirect");

        if (typeof beRedirectCookie == "undefined") {
            $("#beModal").removeClass("hidden");

            Cookies2.set("belg_redirect", 1, { expires: 365, path: "/" });

            $("#beModal").modal();
        }
    }

    function isReturningVisitor() {
        if (typeof window.sessionStorage == "undefined") {
            return true;
        }

        var isReturning = false;
        var returningCookie = Cookies2.get("returning");
        var sessionId = Cookies2.get("PHPSESSID");
        var sessionStored = window.sessionStorage.getItem("returningsess");

        if (
            (typeof sessionStored == "undefined" || sessionStored === null) &&
            typeof sessionId != "undefined"
        ) {
            window.sessionStorage.setItem("returningsess", sessionId);
        }

        if (
            (typeof returningCookie == "undefined" || returningCookie == "") &&
            typeof sessionId != "undefined"
        ) {
            Cookies2.set("returning", sessionId, { expires: 30, path: "/" });
        } else {
            if (
                returningCookie != sessionId ||
                returningCookie != sessionStored
            ) {
                isReturning = true;
            }
        }

        return isReturning;
    }

    function setCartTotalItems(items) {
        if (items === false) {
            items = window.cartTotalItems();
        }

        if ($('[data-js-add="carttotalitems"]').length > 0) {
            $('[data-js-add="carttotalitems"]').text(items);
        }
    }

    window.setCartTotalItems = function (items) {
        setCartTotalItems(items);
    };

    var cartItems = window.cartTotalItems();
    var isReturning = isReturningVisitor();

    if (isReturning && $("#bcreviews").length > 0) {
        $("#bcreviews").removeClass("hidden");
        $(".partners-payments").addClass("withreviews");

        var lazyLoadInstance = new LazyLoad({
            elements_selector: "[data-src]",
        });
    }

    setCartTotalItems(cartItems);

    if (typeof window.sessionStorage != "undefined") {
        var lastSessID = window.sessionStorage.getItem("lsid");
        var sessionId = Cookies2.get("PHPSESSID");
        var lastVisit = Cookies2.get("lastvisit");

        if (
            !isReturning &&
            (typeof lastSessID == "undefined" || lastSessID === null) &&
            typeof sessionId != "undefined"
        ) {
            window.sessionStorage.setItem("lsid", sessionId);
        }

        var currentVisit = new Date();

        var enoughTimeSession = false;

        if (typeof lastVisit != "undefined") {
            lastVisit = parseInt(lastVisit);

            var elapsedHours =
                (currentVisit.getTime() - lastVisit) / 1000 / 3600;

            if (elapsedHours >= 1) {
                enoughTimeSession = true;
            }
        }

        Cookies2.set("lastvisit", currentVisit.getTime(), {
            path: "/",
            expire: 30,
        });

        if (
            isReturning &&
            cartItems > 0 &&
            (typeof lastSessID == "undefined" || lastSessID === null) &&
            enoughTimeSession &&
            window.location.href.indexOf("/cart/") === -1 &&
            window.location.href.indexOf("/checkout/") === -1 &&
            $(window).width() > 767
        ) {
            //get name
            var voornaam = "";
            var checkoutCookie = Cookies2.get("checkoutData");

            if (typeof checkoutCookie != "undefined" && checkoutCookie != "") {
                try {
                    checkoutCookie = JSON.parse(
                        decodeURIComponent(atob(checkoutCookie))
                    );

                    if (typeof checkoutCookie.voornaam != "undefined") {
                        voornaam = " " + checkoutCookie.voornaam;
                    }
                } catch (e) {
                    console.log(e);
                }
            }

            $("#returningCart .modal-body > span").text(
                $("#returningCart .modal-body > span")
                    .text()
                    .replace("%s", voornaam)
            );

            window.sessionStorage.setItem("lsid", sessionId);
            Cookies2.set("lsid", sessionId, { path: "/" });
            $("#returningCart").removeClass("hidden");
            $("#returningCart").modal();
        }
    }

    $(document).on("click", ".cookie-notification--close", function (e) {
        e.preventDefault();

        Cookies2.set("cookie_closed", 1, { expires: 365, path: "/" });

        $(".cookie-notification").remove();
    });

    $(document).on(
        "click",
        ".montage-area.montage-push-area label",
        function (e) {
            return true;
            e.preventDefault();

            $(this).find("input").prop("checked", true).trigger("focus");
        }
    );

    //With fix to focus on click, otherwise the popover wont work in Webkit (chrome, safari...)
    $(".popover-dismiss").popover({
        html: true,
    });
    var is_chrome = navigator.userAgent.indexOf("Chrome") > -1;
    var is_safari = navigator.userAgent.indexOf("Safari") > -1;
    if (!is_chrome && is_safari)
        $(".popover-dismiss").on("click", function (e) {
            e.preventDefault();
            $(this).focus();
        });

    // save the homepage form state

    function saveHomeSearch($form) {
        var serializedArray = $form.serializeArray();

        var fieldsToExclude = ["breedte", "hoogte", "inch", "montagemethode"];

        var cookieData = serializedArray.filter(function (field) {
            return !fieldsToExclude.includes(field.name);
        });

        Cookies2.set("homesearch", JSON.stringify(cookieData), {
            expires: 365,
            path: "/",
        });
    }
    $(document).on(
        "change",
        "#mainsearch select, #mainsearch input",
        function () {
            saveHomeSearch($(this).closest("form"));
        }
    );

    // save the homepage form state
    $("#mainsearchshortcode select").on("change", function () {
        saveHomeSearch($(this).closest("form"));
    });

    $(".show-filters").on("click", function (e) {
        e.preventDefault();
        $(".search-filter-container").show();
        $(this).hide();
    });

    $("#lesslink").on("click", function () {
        $("#morelink").show();
        $("#mfilters").hide();
        return false;
    });

    $("#morelink").on("click", function () {
        $("#mfilters").show();
        $("#morelink").hide();
        $("#lesslink").show();
        return false;
    });

    // set home selects without ruining the cache
    if ($("#mainsearch").length > 0) {
        var homesearchData = Cookies2.get("homesearch");

        var homeMontage = Cookies2.get("homemontage");
        var montageIsSet = false;

        if (typeof homesearchData !== "undefined") {
            searchData = JSON.parse(homesearchData);
            searchData = tireSize.modifyHomeSearch(searchData);

            $.each(searchData, function (index, field) {
                if ($('[name="' + field.name + '"]').is('[type="radio"]')) {
                    if (field.name == "montagemethode") {
                        montageIsSet = true;
                    }

                    if (field.name == "montagemethode" && homeMontage != "") {
                        field.value = homeMontage;
                    }

                    $(
                        '[name="' +
                            field.name +
                            '"][value="' +
                            field.value +
                            '"]'
                    ).prop("checked", true);
                } else {
                    if (
                        $(
                            '[name="' +
                                field.name +
                                '"][data-setable="true"] option[value="' +
                                field.value +
                                '"]'
                        ).length > 0
                    ) {
                        $(
                            '[name="' + field.name + '"][data-setable="true"]'
                        ).val(field.value);
                    } else {
                        var $newOption = $("<option></option>");
                        $newOption.val(field.value).text(field.value);

                        $(
                            '[name="' + field.name + '"][data-setable="true"]'
                        ).append($newOption);

                        $(
                            '[name="' + field.name + '"][data-setable="true"]'
                        ).val(field.value);
                    }

                    if (
                        field.name == "merkcat" &&
                        $("#bcmerkcatbuttons .merkcat-button").length > 0
                    ) {
                        $(
                            '#bcmerkcatbuttons .merkcat-button[data-value="' +
                                field.value +
                                '"]'
                        ).addClass("active");
                    }
                }
            });

            setTimeout(function () {
                if ($('[name="inch"]').val() === null) {
                    $('[name="inch"]').trigger("change");
                } else if ($('[name="hoogte"]').val() === null) {
                    $('[name="hoogte"]').trigger("change");
                } else if ($('[name="breedte"]').val() === null) {
                    $('[name="breedte"]').trigger("change");
                }
            }, 600);
        }

        if (!montageIsSet && homeMontage != "") {
            $('[name="montagemethode"][value="' + homeMontage + '"]').prop(
                "checked",
                true
            );
        }

        $("#mainsearch").addClass("repopulated");
    }

    $(document).on("click", "a.resetFilters", function (e) {
        e.preventDefault();
        Cookies2.remove("filters", { path: "/" });
        Cookies2.remove("filter_url", { path: "/" });

        window.location = $(this).attr("href");
    });

    function buildMainsearchNormaalURL() {
        var breedte = $("#breedte").val();
        var hoogte = $("#hoogte").val();
        var inch = $("#inch").val();

        tireSize.setData(breedte, hoogte, inch);

        var target =
                maintransl.sizesurl +
                "/" +
                breedte +
                "-" +
                hoogte +
                "-" +
                inch +
                "/",
            s = $("#seizoen").val(),
            modelName = $("#preselectedmodel").val(),
            merkSelect = $("#merkselect").val(),
            merkCatSelect = $("#merkcat").val(),
            queryString = false,
            isRunflat = $('[name="runflat"]').val();

        if ($("#preselectedmerk").length > 0)
            merkSelect = $("#preselectedmerk").val();

        if (s != "") {
            queryString = true;
            target += "?seizoen=" + s + "banden";
        }

        if (merkSelect != undefined && merkSelect != "") {
            if (queryString) target += "&";
            else {
                target += "?";
                queryString = true;
            }

            target += "merk=" + merkSelect;
        }

        if (merkCatSelect != "" && typeof merkCatSelect !== "undefined") {
            if (queryString) target += "&";
            else {
                target += "?";
                queryString = true;
            }
            target += "merkcat=" + merkCatSelect;
        }

        if (modelName != "" && typeof modelName !== "undefined") {
            if (queryString) target += "&";
            else {
                target += "?";
                queryString = true;
            }
            target += "model=" + modelName;
        }

        if (isRunflat == "true" && typeof isRunflat !== "undefined") {
            if (queryString) target += "&";
            else {
                target += "?";
                queryString = true;
            }
            target += "runflat=true";
        }

        return target;
    }

    window.buildMainsearchNormaalURL = () => buildMainsearchNormaalURL();

    $(document).on("submit", "#mainsearch.normaal", function (e) {
        e.preventDefault();

        if ($(this).hasClass("montagetest")) return;

        const target = buildMainsearchNormaalURL();

        //Cookies2.set('wait_url', target, { expires: 365, path: '/' });
        window.location = target;
    });

    $(document).on("submit", "#tiremodelSearch", function (e) {
        e.preventDefault();

        var breedte = $(this).find('[name="breedte"]').val(),
            hoogte = $(this).find('[name="hoogte"]').val(),
            inch = $(this).find('[name="inch"]').val();

        tireSize.setData(breedte, hoogte, inch);

        var target =
                maintransl.sizesurl +
                "/" +
                breedte +
                "-" +
                hoogte +
                "-" +
                inch +
                "/",
            s = $("#seizoen").val(),
            queryString = false;

        if (s != "") {
            queryString = true;
            target += "?seizoen=" + s + "banden";
        }

        window.location = target;
    });

    $(document).on("submit", "#mainsearch.montagetest", function (e) {
        e.preventDefault();

        var breedte = $("#breedte").val();
        var hoogte = $("#hoogte").val();
        var inch = $("#inch").val();

        tireSize.setData(breedte, hoogte, inch);

        var target =
                maintransl.sizesurl +
                "/" +
                breedte +
                "-" +
                hoogte +
                "-" +
                inch +
                "/",
            s = $("#seizoen").val(),
            modelName = $("#preselectedmodel").val(),
            merkSelect = $("#merkselect").val(),
            merkCatSelect = $("#merkcat").val(),
            isRunflat = $('[name="runflat"]').val(),
            queryString = false;

        var montageMethode = $(this)
            .find('[name="montagemethode"]:checked')
            .val();

        if (
            $(this).find(".montage-area:not(.skipvalidation)").length > 0 ||
            $(this).find('[name="montagemethode"]:checked').length > 0
        ) {
            var currentStateBestellen = Cookies2.get("bestellenprogress");

            if (currentStateBestellen !== undefined) {
                currentStateBestellen = jQuery.parseJSON(
                    decodeURIComponent(b64_to_utf8(currentStateBestellen))
                );
            } else {
                currentStateBestellen = {};
            }

            if (montageMethode == "zelf") {
                currentStateBestellen["shipping"] = "home";
            } else if (montageMethode == "laten") {
                currentStateBestellen["shipping"] = "garage";
            }

            var bestellenData = btoa(JSON.stringify(currentStateBestellen));

            Cookies2.set("bestellenprogress", bestellenData, {
                expires: 31,
                path: "/",
            });

            Cookies2.set("homemontage", montageMethode, {
                expires: 365,
                path: "/",
            });
        }

        if (s != "") {
            queryString = true;
            target += "?seizoen=" + s + "banden";
        }

        if (merkSelect != "" && typeof merkSelect !== "undefined") {
            if (queryString) target += "&";
            else {
                target += "?";
                queryString = true;
            }
            target += "merk=" + merkSelect;
        }

        if (merkCatSelect != "" && typeof merkCatSelect !== "undefined") {
            if (queryString) target += "&";
            else {
                target += "?";
                queryString = true;
            }
            target += "merkcat=" + merkCatSelect;
        }

        if (modelName != "" && typeof modelName !== "undefined") {
            if (queryString) target += "&";
            else {
                target += "?";
                queryString = true;
            }
            target += "model=" + modelName;
        }

        if (isRunflat == "true" && typeof isRunflat !== "undefined") {
            if (queryString) target += "&";
            else {
                target += "?";
                queryString = true;
            }
            target += "runflat=true";
        }

        //Cookies2.set('wait_url', target, { expires: 365, path: '/' });
        window.location = target;
    });

    $(document).on("submit", "#mainsearchshortcode", function (e) {
        e.preventDefault();
        var target = "/bandenmaten/",
            s = $("#seizoenshortcode").val();

        if (s != "") {
            target += s + "banden/";
        }
        var m = $("#merkselectshortcode").val();
        if (m != "") {
            target += m + "/";
        }

        var breedte = $("#breedteshortcode").val();
        var hoogte = $("#hoogteshortcode").val();
        var inch = $("#inchshortcode").val();

        tireSize.setData(breedte, hoogte, inch);

        target += breedte + "-" + hoogte + "-" + inch + "/";

        window.location = target;
    });

    $(document).on("hidden.bs.modal", "#videodiag", function () {
        // pause video
        $("video#leverancier").get(0).pause();
    });

    window.populateAutocompleteField = function (
        $field,
        fieldValues,
        $wrap,
        defaultValue,
        valuePrefix = ""
    ) {
        $field.empty();

        $.when(
            $.each(fieldValues, function (index, value) {
                $field.append(
                    '<option value="' +
                        valuePrefix +
                        value +
                        '">' +
                        valuePrefix +
                        value +
                        "</option>"
                );
            })
        ).done(function () {
            $field.val(defaultValue);
            $field.closest("div").removeClass("dropup");
        });
    };

    window.sizesAutocomplete = function (
        $wrap,
        $changed,
        $breedte,
        $hoogte,
        $inch,
        $load,
        $speed,
        $seizoen,
        $brand,
        $model,
        forceBrand = false,
        skipModelCheck = false
    ) {
        var breedte = $breedte.val();
        var hoogte = $hoogte.val();
        var inch = $inch.val();
        var seizoen = $seizoen.val();
        var loadIndex = "";
        var speedIndex = "";
        var brand = typeof $brand == "object" ? $brand.val() : "";
        var model = typeof $model == "object" ? $model.val() : "";

        var bandenmatenData = {
            action: "getsizes",
            breedte: breedte,
            hoogte: hoogte,
            inch: inch,
            seizoen: seizoen,
            merk: brand,
            speedIndex: speedIndex,
            loadIndex: loadIndex,
            changedField: $changed.attr("name"),
            forceBrand: forceBrand,
            model: model,
            skipModelCheck: skipModelCheck,
        };

        var ajaxUrl = $("[data-size-autocomplete-url]").data(
            "size-autocomplete-url"
        );
        $wrap.find(".btn-group.bootstrap-select.dropup").removeClass("dropup");

        $.getJSON(
            ajaxUrl,
            bandenmatenData,
            function (response) {
                window.populateAutocompleteField(
                    $breedte,
                    response.breedte,
                    $wrap,
                    breedte
                );
                window.populateAutocompleteField(
                    $hoogte,
                    response.hoogte,
                    $wrap,
                    hoogte
                );
                window.populateAutocompleteField(
                    $inch,
                    response.inch,
                    $wrap,
                    inch,
                    "R"
                );

                $wrap.find("select").each(function () {
                    if ($(this).find("option:checked").length == 0) {
                        $(this).val($(this).find("option:first").val());
                    }
                });
            },
            "JSON"
        );
    };

    $(document).on(
        "change",
        "#mainsearch.autocompleteSearch select",
        function () {
            var forceBrand = false;
            var model = $("#preselectedmodel").val();
            var skipModelCheck = false;

            if ($('[name="skipmodelcheck"]').length > 0)
                skipModelCheck = $('[name="skipmodelcheck"]').val();

            if ($("#preselectedmerk").length > 0) {
                forceBrand = true;
            }

            var $wrap = $("#mainsearch.autocompleteSearch");

            window.sizesAutocomplete(
                $wrap,
                $(this),
                $("#breedte"),
                $("#hoogte"),
                $("#inch"),
                "",
                "",
                $("#seizoen"),
                $("#preselectedmerk"),
                $("#preselectedmodel"),
                forceBrand,
                skipModelCheck
            );
        }
    );

    $(document).on(
        "focus",
        'form.ab-search-form.abmobile [name="q"]',
        function (e) {
            var placeholder = this.getAttribute("placeholder");

            if (
                this.value.length === 0 &&
                typeof placeholder != "undefined" &&
                placeholder.length > 0
            ) {
                this.value = placeholder;
            }

            showCloseButton();
        }
    );

    $(document).on(
        "keyup",
        'form.ab-search-form.abmobile [name="q"]',
        function (e) {
            showCloseButton();
        }
    );

    $(document).on("submit", "form.ab-search-form.abmobile", function (e) {
        var $input = $('form.ab-search-form.abmobile [name="q"]');
        var searchQuery = $input.val();

        if (searchQuery.length === 0) {
            e.preventDefault();
            $input.focus();
            return false;
        }
    });

    $(document).on(
        "click",
        "form:not(.mobile-fs-search) .close-search",
        function () {
            var $input = $('form.ab-search-form.abmobile [name="q"]');
            $input.val("").attr("placeholder", "");
            $("form.ab-search-form.abmobile").addClass("hide-close-button");
            $input.focus();
        }
    );

    function showCloseButton() {
        var $input = $('form.ab-search-form.abmobile [name="q"]');
        var $searchForm = $("form.ab-search-form.abmobile");
        var placeholder = $input.attr("placeholder");

        if ($input.length === 0) return;

        if (
            $input.val().length > 0 ||
            (typeof placeholder != "undefined" && placeholder.length > 0)
        ) {
            $searchForm.removeClass("hide-close-button");
            return;
        }

        $searchForm.addClass("hide-close-button");
    }

    showCloseButton();

    $(document).on(
        "hidden.bs.select",
        "form.autocompleteSearch select",
        function () {
            $(
                "form.autocompleteSearch .btn-group.bootstrap-select.dropup"
            ).removeClass("dropup");
        }
    );

    $(document).on("change", '.absearch [name="montagemethode"]', function () {
        $(".absearch .first .error").addClass("hidden");

        $(".absearch .search-left").removeClass("expanded");

        if (
            $('.absearch [name="montagemethode"]:checked').val() == "laten" &&
            $(".montage-area .second").length > 0
        ) {
            $(".montage-area .first").addClass("hidden");
            $(".montage-area .second").removeClass("hidden");
            $(".absearch .search-left").addClass("expanded");
        }
    });

    $(document).on("change keyup", ".absearch .second input", function () {
        $(".absearch .second .error").addClass("hidden");
    });

    $(document).on("touchstart", ".abmobileusps a", function () {
        var $li = $(this).closest("li");

        if ($li.find(".popover").length > 0) {
            var $anchor = $(this);
            var blurInterval = setInterval(function () {
                $anchor.blur();
            }, 1);

            setTimeout(function () {
                clearInterval(blurInterval);
            }, 250);
        }
    });

    $(document).on("click", ".mobilereviewpopup i", function (e) {
        $(".mobileratingpopover").popover("hide");
    });

    function windowResPlaceholder() {
        var windowWidth = $(window).width();

        if (windowWidth < 992) {
            $(".header-left .searchbar input").attr(
                "placeholder",
                $(".header-left .searchbar input").attr(
                    "data-placeholder-short"
                )
            );
        } else {
            $(".header-left .searchbar input").attr(
                "placeholder",
                $(".header-left .searchbar input").attr("data-placeholder-long")
            );
        }
    }

    $(window).on("resize", function () {
        windowResPlaceholder();
    });
    windowResPlaceholder();

    $(document).on("click", ".homereview-based .popover-dismiss", function (e) {
        e.preventDefault();
    });

    $(document).on(
        "click",
        ".tim-popup .tim-collapsed > a:not(.no-modal)",
        function (e) {
            e.preventDefault();
            $(".tim-popup").addClass("opened");
        }
    );

    $(document).on("click", ".tim-expanded .tim-chat-header > a", function (e) {
        e.preventDefault();
        $(".tim-popup").removeClass("opened");
        return false;
    });
    var lazyLoadInstance = new LazyLoad({
        elements_selector: "[data-src]",
    });

    $(window).on("scroll resize DOMContentLoaded", function () {
        if ($(this).scrollTop() > $(window).height()) {
            $(".bc-mobile-scroll:hidden").stop(true, true).fadeIn();
        } else {
            $(".bc-mobile-scroll").stop(true, true).fadeOut();
        }
    });

    $(document).on("click", ".bc-mobile-scroll", function (e) {
        e.preventDefault();
        $("html,body").animate({ scrollTop: 0 }, "1000");
    });

    function merkcatSelect() {
        if ($("#merkcat").length === 0) return;

        var selectValue = $("#merkcat").val();

        $("#bcmerkcatbuttons .merkcat-button.active").removeClass("active");

        $(
            '#bcmerkcatbuttons .merkcat-button[data-value="' +
                selectValue +
                '"]'
        ).addClass("active");
    }

    $(document).on("click", "#bcmerkcatbuttons .merkcat-button", function () {
        var selectedValue = $(this).attr("data-value");

        $("#merkcat").val(selectedValue).trigger("change");
        merkcatSelect();
    });

    merkcatSelect();

    /* Tablet menu Stu*/
    $(document).on(
        "touchstart",
        ".newheader #navbar-collapse-menu li.dropdown",
        function (e) {
            e.preventDefault();
        }
    );

    $(".homepage-content-area a.read-more-link").on("click", function () {
        $(this).attr("style", "display: none !important");
    });

    $(".homepage-content-area a.read-less-link").on("click", function () {
        $(this)
            .closest(".readmore-wrapper")
            .find(".read-more-link")
            .removeAttr("style");
    });

    /* Mobile Menu Stuff */
    $(document).on("click", ".bc-mobile-menu-toggle", function (e) {
        e.preventDefault();

        if ($("#mobileMenuModal").length === 0) {
            var $menu = $("#navbar-collapse-menu .row.top > ul").clone();
            var $mobileMenuModal = $(
                '<div id="mobileMenuModal" class="modal fade" role="dialog">' +
                    '<div class="modal-dialog">' +
                    '<div class="modal-content">' +
                    '<div class="modal-header">' +
                    '<button type="button" class="close" data-dismiss="modal">&times;</button>' +
                    "<h4>MENU</h4>" +
                    "</div>" +
                    '<div class="modal-body">' +
                    "</div>" +
                    "</div>" +
                    "</div>" +
                    "</div>"
            );

            $menu.appendTo($mobileMenuModal.find(".modal-body"));

            $mobileMenuModal.appendTo("body");
        }

        $("#mobileMenuModal").modal();
    });

    $(document).on("click", "[data-opens]", function (e) {
        if ($(window).width() < 768) {
            e.preventDefault();
            var opens = $(this).attr("data-opens");

            if ($(this).hasClass("opened")) {
                $(this).removeClass("opened");
                $('ul[data-openedby="' + opens + '"]').removeClass("opened");
                $(
                    'span.menu-heading[data-openedby="' + opens + '"]'
                ).removeClass("subopened");
                $(this).blur();
            } else {
                $(this).addClass("opened");
                $('ul[data-openedby="' + opens + '"]').addClass("opened");
                $('span.menu-heading[data-openedby="' + opens + '"]').addClass(
                    "subopened"
                );
            }
        }
    });

    if ($(window).width() < 768) {
        $("#mobile-slider-usps").carousel({
            interval: 5000,
        });
        $("#mobile-slider-usps").carousel("cycle");
    }

    // Mobile header phone icon only if helpdesk available
    function checkIfOpen() {
        var datum = new Date();

        if (
            datum.getDay() > 0 &&
            datum.getDay() < 6 &&
            datum.getHours() >= 9 &&
            datum.getHours() < 17
        ) {
            var $phone = document.querySelector(".phone");

            if ($phone === null) {
                return;
            }

            $phone.classList.add("bc-is-open");
        }
    }

    if (document.querySelector("body").classList.contains("nl")) {
        try {
            checkIfOpen();
        } catch (e) {
            console.error(e);
        }
    }
});

function addToCart(
    supplier,
    product,
    count,
    extra,
    price = "",
    endpoint = false
) {
    //Add a single product to the shopping cart
    var form = $(
        '<form action="' + maintransl.carturl + '" method="post"></form>'
    );
    $('<input type="hidden" name="product1_s">').val(supplier).appendTo(form);
    $('<input type="hidden" name="product1_p">').val(product).appendTo(form);
    $('<input type="hidden" name="product1_c">').val(count).appendTo(form);
    $('<input type="hidden" name="product1_refprice">')
        .val(price)
        .appendTo(form);

    if (!!extra) {
        $('<input type="hidden" name="product1_e">').val(extra).appendTo(form);
    }

    if (endpoint === false) {
        form.appendTo($("body"));
        form.trigger("submit");
        return;
    }

    $('<input type="hidden" name="skipoutput">').val(1).appendTo(form);

    var formData = form.serialize();

    $.ajax({
        url: maintransl.carturl,
        method: "POST",
        data: formData,
        success: function (response) {
            if (endpoint !== null) {
                window.location = endpoint;
            }
        },
        error: function (xhr, status, error) {
            console.error("Failed to add item to cart:", error);
        },
    });
}

function updateCart(supplier, product, count) {
    var ventiel = $('[name="ventiel"]:checked').val();

    $.post(
        getBCBaseURL() + "/cart-update/",
        {
            product1_s: supplier,
            product1_p: product,
            product1_c: count,
            ventiel: ventiel,
        },
        function (html) {
            window.location.reload();
        }
    );
}

function deleteCart(supplier, product) {
    var ventiel = $('[name="ventiel"]:checked').val();

    $.post(
        getBCBaseURL() + "/cart-del/",
        { product1_s: supplier, product1_p: product, ventiel: ventiel },
        function (html) {
            if (typeof dataLayer !== "undefined") {
                dataLayer.push({
                    event: "removeFromCart",
                    ecommerce: {
                        remove: {
                            // 'remove' actionFieldObject measures.
                            products: [
                                {
                                    //  removing a product to a shopping cart.
                                    id: product,
                                },
                            ],
                        },
                    },
                    eventCallback: function () {
                        window.location.reload();
                    },
                });
            } else {
                window.location.reload();
            }
        }
    );
}

function updateCartDisplay(count) {
    $("#cartcount").text(count);
}

function onEventLog(msg) {
    return function () {
        console.log(msg);
    };
}

$(".newheader #navbar-collapse-menu li.dropdown")
    .on("mouseenter", function () {
        $(this).find(".dropdown-menu").show();
        //   $(this).addClass('dropdown-is-open');
    })
    .on("mouseleave", function () {
        $(this).find(".dropdown-menu").hide();
        //   $(this).removeClass('dropdown-is-open');
    });

window.updateHomeSearch = function (key, value) {
    var homesearchData = Cookies2.get("homesearch");

    if (typeof homesearchData !== "undefined") {
        searchData = JSON.parse(homesearchData);

        $.each(searchData, function (index, field) {
            if (field.name == key) {
                field.value = value;
            }
        });

        var cookieData = JSON.stringify(searchData);
        Cookies2.set("homesearch", cookieData, { expires: 365, path: "/" });
    } else {
        var cookieData = JSON.stringify([{ name: key, value: value }]);
        Cookies2.set("homesearch", cookieData, { expires: 365, path: "/" });
    }
};

// Language switch BE
$(".langswitch").each(function () {
    var targetLang = $(this).attr("data-lang");
    var fallback = $(this).attr("data-fallback-href");
    var hrefLangHref =
        $('head link[hreflang="' + targetLang + '"]').attr("href") || fallback;

    $(this).attr("href", hrefLangHref);
});

// Language Switch
$('.langswitch[data-langswitchid][data-langswitchid!=""]').each(function (
    index
) {
    var langswitchId = $(this).data("langswitchid");
    $(this).on("focusout", function () {
        setTimeout(function () {
            var hasFocus = !!($(this).find(":focus").length > 0);
            if (!hasFocus) {
                $(`#${langswitchId}`).collapse("hide");
            }
        }, 100);
    });
});

// Cookie wall body class
$('[data-role="cwall"]').on("shown.bs.modal", function () {
    $("body").addClass("blur-background");
});
$('[data-role="cwall"]').on("hide.bs.modal", function () {
    $("body").removeClass("blur-background");
});

/*
	CHECKRADIOS - jQuery plugin to allow custom styling of checkboxes
	by Chris McGuckin (https://github.com/cosmicwheels)
	
	
	License: MIT (http://opensource.org/licenses/MIT)
	
	
	Credits:
	---------------------------------------------------------------------------------
	
	icomoon (http://icomoon.io/)
	
	Please refer to the icomoon website for the license regarding their icons.
	
	---------------------------------------------------------------------------------
	
	Fontawesome (http://fortawesome.github.io/Font-Awesome/)
	
	Please refer to the fontawesome website for the license regarding their icons.
	
	---------------------------------------------------------------------------------
	
	Stephan Richter (https://github.com/strichter)
	
	Thanks to Stephan for pointing out and helping to add the triggering of events 
	to help further mimic the checkboxes and radios as well as providing other
	important bug fixes.
	
	---------------------------------------------------------------------------------
	---------------------------------------------------------------------------------
	

*/(function(e){e.fn.checkradios=function(t){var n=this,r=e.extend({checkbox:{iconClass:"icon-checkradios-checkmark"},radio:{iconClass:"icon-checkradios-circle"},onChange:function(e,t,n){}},t),i={checkbox:function(t){var n=this;if(!t.parent().hasClass("checkradios-checkbox")){var i=t.attr("class");i===undefined&&(i="");var s=t.wrap('<div class="checkradios-checkbox '+i+'"/>'),o=s.parent();s.is(":checked")?n.checkboxEnable(s):n.checkboxDisable(s);t.keypress(function(e){var t=e.keyCode;(t<1||t==13||t==32)&&o.click()});t.on({focusin:function(){o.addClass("focus")},focusout:function(){var t=e(this);setTimeout(function(){t.is(":focus")||o.removeClass("focus")},10)}});o.mousedown(function(){setTimeout(function(){t.focus()},10)});t.click(function(e){e.stopPropagation();e.preventDefault()});o.click(function(){if(s.is(":checked")){n.checkboxDisable(s);r.onChange(!1,o,s)}else{n.checkboxEnable(s);r.onChange(!0,o,s)}return!1})}},radio:function(t){var n=this;if(!t.parent().hasClass("checkradios-radio")){var i=t.attr("class");i===undefined&&(i="");var s=t.wrap('<div class="checkradios-radio '+i+'"/>'),o=s.parent();s.is(":checked")?n.radioEnable(s):n.radioDisable(s);t.on({focusin:function(){o.addClass("focus");n.radioEnable(s);var t=s.attr("name"),i=e('input[name="'+t+'"]');i.each(function(){if(e(this).is(":checked")){n.radioEnable(e(this));r.onChange(!0,e(this).parent(),e(this))}else{n.radioDisable(e(this));r.onChange(!1,e(this).parent(),e(this))}})},focusout:function(){var t=e(this);setTimeout(function(){t.is(":focus")||o.removeClass("focus")},10)}});o.click(function(){t.focus()});t.click(function(e){e.stopPropagation();e.preventDefault()})}},checkboxEnable:function(e){e.parent().removeClass(r.checkbox.iconClass);e.parent().removeClass("unchecked");e.parent().addClass(r.checkbox.iconClass);e.parent().addClass("checked");e.prop("checked",!0).trigger("change")},checkboxDisable:function(e){e.parent().removeClass(r.checkbox.iconClass);e.parent().addClass("unchecked");e.prop("checked",!1).trigger("change")},radioEnable:function(e){e.parent().removeClass(r.radio.iconClass);e.parent().removeClass("unchecked");e.parent().addClass(r.radio.iconClass);e.parent().addClass("checked");e.prop("checked",!0).trigger("change")},radioDisable:function(e){e.parent().removeClass("checked");e.parent().removeClass(r.radio.iconClass);e.parent().addClass("unchecked");e.prop("checked",!1).trigger("change")}};n.each(function(t,n){var r=e(this);r.is("input[type=checkbox]")&&i.checkbox(r);r.is("input[type=radio]")&&i.radio(r);return this})}})(jQuery);

jQuery(document).ready(function(){

    jQuery('.checkradios').checkradios();

});
(function ($) {})(jQuery);

/*! instant.page v5.1.0 - (C) 2019-2020 Alexandre Dieulot - https://instant.page/license */

let mouseoverTimer;
let lastTouchTimestamp;
const prefetches = new Set();
const prefetchElement = document.createElement("link");
const isSupported =
    prefetchElement.relList &&
    prefetchElement.relList.supports &&
    prefetchElement.relList.supports("prefetch") &&
    window.IntersectionObserver &&
    "isIntersecting" in IntersectionObserverEntry.prototype;
const allowQueryString = "instantAllowQueryString" in document.body.dataset;
const allowExternalLinks = "instantAllowExternalLinks" in document.body.dataset;
const useWhitelist = "instantWhitelist" in document.body.dataset;
const mousedownShortcut = "instantMousedownShortcut" in document.body.dataset;
const DELAY_TO_NOT_BE_CONSIDERED_A_TOUCH_INITIATED_ACTION = 1111;

let delayOnHover = 65;
let useMousedown = false;
let useMousedownOnly = false;
let useViewport = false;

if ("instantIntensity" in document.body.dataset) {
    const intensity = document.body.dataset.instantIntensity;

    if (intensity.substr(0, "mousedown".length) == "mousedown") {
        useMousedown = true;
        if (intensity == "mousedown-only") {
            useMousedownOnly = true;
        }
    } else if (intensity.substr(0, "viewport".length) == "viewport") {
        if (
            !(
                navigator.connection &&
                (navigator.connection.saveData ||
                    (navigator.connection.effectiveType &&
                        navigator.connection.effectiveType.includes("2g")))
            )
        ) {
            if (intensity == "viewport") {
                /* Biggest iPhone resolution (which we want): 414 × 896 = 370944
                 * Small 7" tablet resolution (which we don’t want): 600 × 1024 = 614400
                 * Note that the viewport (which we check here) is smaller than the resolution due to the UI’s chrome */
                if (
                    document.documentElement.clientWidth *
                        document.documentElement.clientHeight <
                    450000
                ) {
                    useViewport = true;
                }
            } else if (intensity == "viewport-all") {
                useViewport = true;
            }
        }
    } else {
        const milliseconds = parseInt(intensity);
        if (!isNaN(milliseconds)) {
            delayOnHover = milliseconds;
        }
    }
}

if (isSupported) {
    const eventListenersOptions = {
        capture: true,
        passive: true,
    };

    if (!useMousedownOnly) {
        document.addEventListener(
            "touchstart",
            touchstartListener,
            eventListenersOptions
        );
    }

    if (!useMousedown) {
        document.addEventListener(
            "mouseover",
            mouseoverListener,
            eventListenersOptions
        );
    } else if (!mousedownShortcut) {
        document.addEventListener(
            "mousedown",
            mousedownListener,
            eventListenersOptions
        );
    }

    if (mousedownShortcut) {
        document.addEventListener(
            "mousedown",
            mousedownShortcutListener,
            eventListenersOptions
        );
    }

    if (useViewport) {
        let triggeringFunction;
        if (window.requestIdleCallback) {
            triggeringFunction = (callback) => {
                requestIdleCallback(callback, {
                    timeout: 1500,
                });
            };
        } else {
            triggeringFunction = (callback) => {
                callback();
            };
        }

        triggeringFunction(() => {
            const intersectionObserver = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const linkElement = entry.target;
                        intersectionObserver.unobserve(linkElement);
                        preload(linkElement.href);
                    }
                });
            });

            document.querySelectorAll("a").forEach((linkElement) => {
                if (isPreloadable(linkElement)) {
                    intersectionObserver.observe(linkElement);
                }
            });
        });
    }
}

function touchstartListener(event) {
    /* Chrome on Android calls mouseover before touchcancel so `lastTouchTimestamp`
     * must be assigned on touchstart to be measured on mouseover. */
    lastTouchTimestamp = performance.now();

    const linkElement = event.target.closest("a");

    if (!isPreloadable(linkElement)) {
        return;
    }

    preload(linkElement.href);
}

function mouseoverListener(event) {
    if (
        performance.now() - lastTouchTimestamp <
        DELAY_TO_NOT_BE_CONSIDERED_A_TOUCH_INITIATED_ACTION
    ) {
        return;
    }

    const linkElement = event.target.closest("a");

    if (!isPreloadable(linkElement)) {
        return;
    }

    linkElement.addEventListener("mouseout", mouseoutListener, {
        passive: true,
    });

    mouseoverTimer = setTimeout(() => {
        preload(linkElement.href);
        mouseoverTimer = undefined;
    }, delayOnHover);
}

function mousedownListener(event) {
    const linkElement = event.target.closest("a");

    if (!isPreloadable(linkElement)) {
        return;
    }

    preload(linkElement.href);
}

function mouseoutListener(event) {
    if (
        event.relatedTarget &&
        event.target.closest("a") == event.relatedTarget.closest("a")
    ) {
        return;
    }

    if (mouseoverTimer) {
        clearTimeout(mouseoverTimer);
        mouseoverTimer = undefined;
    }
}

function mousedownShortcutListener(event) {
    if (
        performance.now() - lastTouchTimestamp <
        DELAY_TO_NOT_BE_CONSIDERED_A_TOUCH_INITIATED_ACTION
    ) {
        return;
    }

    const linkElement = event.target.closest("a");

    if (event.which > 1 || event.metaKey || event.ctrlKey) {
        return;
    }

    if (!linkElement) {
        return;
    }

    linkElement.addEventListener(
        "click",
        function (event) {
            if (event.detail == 1337) {
                return;
            }

            event.preventDefault();
        },
        { capture: true, passive: false, once: true }
    );

    const customEvent = new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: false,
        detail: 1337,
    });
    linkElement.dispatchEvent(customEvent);
}

function isPreloadable(linkElement) {
    if (!linkElement || !linkElement.href) {
        return;
    }

    if (useWhitelist && !("instant" in linkElement.dataset)) {
        return;
    }

    if (
        !allowExternalLinks &&
        linkElement.origin != location.origin &&
        !("instant" in linkElement.dataset)
    ) {
        return;
    }

    if (!["http:", "https:"].includes(linkElement.protocol)) {
        return;
    }

    if (linkElement.protocol == "http:" && location.protocol == "https:") {
        return;
    }

    if (
        !allowQueryString &&
        linkElement.search &&
        !("instant" in linkElement.dataset)
    ) {
        return;
    }

    if (
        linkElement.hash &&
        linkElement.pathname + linkElement.search ==
            location.pathname + location.search
    ) {
        return;
    }

    if ("noInstant" in linkElement.dataset) {
        return;
    }

    return true;
}

function preload(url) {
    if (prefetches.has(url)) {
        return;
    }

    const prefetcher = document.createElement("link");
    prefetcher.rel = "prefetch";
    prefetcher.href = url;
    document.head.appendChild(prefetcher);

    prefetches.add(url);
}

class AutoSuggest {
    constructor() {
        this.searchQuery = null;
        this.autosuggestionTimeout = null;
        this.initialize();
        this.addMobile();
    }

    getSearchBaseURL() {
        var searchpage = "/search/";

        var $baseElement = document.querySelector("[data-search-page]");

        if ($baseElement) {
            var searchpage = $baseElement.getAttribute("data-search-page");
        }

        return searchpage;
    }

    initialize() {
        const field = document.querySelector(
            '.newheaderlogo .searchbar [name="q"]'
        );
        if (field) {
            this.addAutocompleteListeners(field);
        }
    }

    isMobileSearch() {
        return window.innerWidth < 768;
    }

    focusAtEnd(inputElement) {
        if (!inputElement) return;

        var valueLength = inputElement.value.length;
        inputElement.focus();
        inputElement.setSelectionRange(valueLength, valueLength);
    }

    addMobile() {
        const field = document.querySelector('.abmobile [name="q"]');
        if (field) {
            this.addMobileAutocompleteListeners(field);
        }
    }

    openAutocomplete(input = null, suggestions = null) {
        document.body.classList.add("autosuggest-open");
        this.createOrUpdateSuggestions(input, suggestions);
        this.createBackdropOrOpenFullscreen(input);
    }

    createOrUpdateSuggestions(input, suggestions) {
        if (!suggestions) return;

        const autosuggestOutput = document.querySelector(".autosuggest-output");
        if (autosuggestOutput) {
            autosuggestOutput.innerHTML = suggestions.innerHTML;
        } else {
            input.after(suggestions);
        }

        document
            .querySelectorAll(".autosuggest-output a[data-search]")
            .forEach((anchor) => {
                anchor.addEventListener("click", (e) => {
                    e.preventDefault();
                    window.location = `${this.getSearchBaseURL()}?q=${encodeURIComponent(
                        anchor.getAttribute("data-search")
                    )}`;
                    return false;
                });
            });
    }

    createFullscreenSearch() {
        if (document.querySelector(".fullscreen-search")) {
            this.focusAtEnd(
                document
                    .querySelector(".fullscreen-search")
                    .querySelector("input")
            );
            return;
        }

        const $full = document.createElement("div");
        $full.className = "fullscreen-search";

        var inputValue = this.searchQuery;

        if (inputValue === null) {
            let $oldInput = document.querySelector(
                '.navbar-header .searchbar [name="q"], .navbar-header + .ab-search-form .searchbar [name="q"]'
            );

            if ($oldInput && $oldInput.value.length > 0) {
                inputValue = $oldInput.value;
            } else {
                if ($oldInput && $oldInput.placeholder.length > 0) {
                    inputValue = $oldInput.placeholder;
                } else inputValue = "";
            }
        }

        $full.innerHTML = `
        <div class="top-search-bar">
            <form class="search-form hide-close-button mobile-fs-search" action="${this.getSearchBaseURL()}" data-autocomplete-url="/wp-content/themes/bandenconcurrent/search/json-autosuggest.php">
                <div class="input-group">
                    <input type="text" class="form-control" autocomplete="off" name="q" value="${inputValue}" placeholder="">
                    <span class="input-group-btn close-search">
                    <a type="button" href="#"><i class="fa fa-times"></i></a>
                    </span>
                    <span class="input-group-btn">
                    <button class="btn btn-default" type="submit"><i class="glyphicon glyphicon-search"></i></button>
                    </span>
                </div>
            </form>
            <div class="cancel-search">
                <a href="#">Annuleren</a>
            </div>
        </div>

        <div class="autosuggest-output"></div>
       `;

        var $this = this;
        $full
            .querySelector(".close-search > a")
            .addEventListener("click", function (e) {
                e.preventDefault();
                var $form = this.closest("form");
                var $input = $form.querySelector("input");
                $input.value = "";
                $form.classList.add("hide-close-button");

                $this.focusAtEnd($input);

                const $oldInput = document.querySelector(
                    '.navbar-header .searchbar [name="q"]'
                );
                if ($oldInput) {
                    $oldInput.value = "";
                    $oldInput.placeholder = "";
                }
            });

        this.addAutocompleteListeners($full.querySelector("input"));

        $full
            .querySelector(".cancel-search a")
            .addEventListener("click", function (e) {
                e.preventDefault();

                document.body.classList.remove("autosuggest-open");
            });

        document.body.append($full);

        this.focusAtEnd($full.querySelector("input"));
    }

    createBackdropOrOpenFullscreen(input) {
        const existingBackdrop = document.querySelector(
            ".autosuggest-backdrop"
        );
        if (existingBackdrop) {
            existingBackdrop.remove();
        }

        if (this.isMobileSearch()) {
            this.createFullscreenSearch();
            return;
        }

        const backdrop = document.createElement("div");
        backdrop.className = "autosuggest-backdrop";
        backdrop.addEventListener("click", this.closeAutocomplete);
        input.after(backdrop);
    }

    renderPageByType(section, page) {
        switch (page.type) {
            case "brand_page":
                return `<a href="/bandenmerken/${page.key}/" data-type="brand_page" style="display: none;">${page.title}</a><a data-search="${page.search}" data-type="brand_page">${page.title}</a>`;
                break;

            default:
                return `<a data-search="${page.search}">${page.title}</a>`;
        }
    }

    buildAutocompleteOutput(json) {
        if (json.error) return null;

        const output = document.createElement("div");
        output.className = "autosuggest-output";

        output.innerHTML = this.createOutputHtml(json);
        this.populateProductsContainer(output, json.results.models);

        return output;
    }

    createOutputHtml(json) {
        const pagesOutput = json.results.pages
            .map((page) => this.renderPageByType("pages", page))
            .join("");

        return `${this.createQuerySectionHtml(
            json.query
        )}${this.createPagesContainerHtml(
            pagesOutput
        )}<div class="products-container"></div>`;
    }

    createQuerySectionHtml(query) {
        if (!query || query.length === 0) return "";

        return `<div class="search-query"><div class="search-query-inner"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M2 2 L2 8 L8 8 M6 6 L8 8 L6 10" fill="none" stroke="currentColor" stroke_linecap="round" stroke_linejoin="round" stroke_width="2"/></svg><a data-search="${query}">${maintransl.autosuggest.searchfor.replace(
            "%s",
            query
        )}</a></div></div>`;
    }

    createPagesContainerHtml(pagesOutput) {
        return pagesOutput.length > 0
            ? `<div class="pages-container">${pagesOutput}</div>`
            : "";
    }

    populateProductsContainer(output, models) {
        if (models && models.length > 0) {
            const productsHTML = models
                .map((model) => this.createProductHtml(model))
                .join("");
            output.querySelector(".products-container").innerHTML =
                productsHTML;
        }
    }

    createProductHtml(model) {
        let productImage = model.image?.replace(".png", "").replace(".jpg", "");
        productImage = productImage
            ? `https://c-1.otirodn.net/product-images/small/${productImage}.webp`
            : `/wp-content/themes/bandenconcurrent/img-nl/not2.webp`;

        let productPrice = model.price
            ?.toFixed(2)
            .replace(".00", "")
            .replace(".", ",");

        let isModelURL = true;

        let actionAttribute = `href="${this.getSearchBaseURL()}?q=${
            model.brand
        } ${model.model}&dFR[merkFull][0]=${model.brand}&dFR[beschrijving][0]=${
            model.model
        }"`;

        if (model.size) {
            const sizeData = tireSize.parse(model.size);
            actionAttribute = `href="${maintransl.sizesurl}/${sizeData[0]}-${sizeData[1]}-R${sizeData[2]}/?dFR[merkFull][0]=${model.brand}&dFR[beschrijving][0]=${model.model}"`;

            isModelURL = false;
        }

        if (!isModelURL) {
            //default van voor de test

            return `
                <a ${actionAttribute}>
                    <div class="products-inner">
                        <img src="${productImage}" alt="${model.brand} ${
                model.model
            }">
                        <div class="products-inner-data">
                            <span class="product-name">${model.brand} ${
                model.model
            }</span>
                            ${
                                model.size
                                    ? `<span class="product-size">${model.size}</span>`
                                    : ""
                            }
                            ${
                                productPrice
                                    ? `<span class="product-price">${maintransl.autosuggest.pricefrom.replace(
                                          "%s",
                                          productPrice
                                      )}</span>`
                                    : ""
                            }
                        </div>
                        <div class="products-brand-area">
                            ${
                                model.brand_code
                                    ? `<img src="/wp-content/themes/bandenconcurrent/img/merken/${model.brand_code}.webp"/>`
                                    : ""
                            }
                        </div>
                    </div>
                </a>`;
        }

        return `
        <a ${actionAttribute} data-type="model_search">
            <div class="products-inner">
                <img src="${productImage}" alt="${model.brand} ${model.model}">
                <div class="products-inner-data">
                    <span class="product-name">${model.brand} ${
            model.model
        }</span>
                    ${
                        model.size
                            ? `<span class="product-size">${model.size}</span>`
                            : ""
                    }
                    ${
                        productPrice
                            ? `<span class="product-price">${maintransl.autosuggest.pricefrom.replace(
                                  "%s",
                                  productPrice
                              )}</span>`
                            : ""
                    }
                </div>
                <div class="products-brand-area">
                    ${
                        model.brand_code
                            ? `<img src="/wp-content/themes/bandenconcurrent/img/merken/${model.brand_code}.webp"/>`
                            : ""
                    }
                </div>
            </div>
        </a>
        
        <a href="/bandenmerken/${model.brand_slug}/${
            model.model_slug
        }/" data-type="model_page" style="display: none;">
            <div class="products-inner">
                <img src="${productImage}" alt="${model.brand} ${model.model}">
                <div class="products-inner-data">
                    <span class="product-name">${model.brand} ${
            model.model
        }</span>
                    ${
                        model.size
                            ? `<span class="product-size">${model.size}</span>`
                            : ""
                    }
                    ${
                        productPrice
                            ? `<span class="product-price">${maintransl.autosuggest.pricefrom.replace(
                                  "%s",
                                  productPrice
                              )}</span>`
                            : ""
                    }
                </div>
                <div class="products-brand-area">
                    ${
                        model.brand_code
                            ? `<img src="/wp-content/themes/bandenconcurrent/img/merken/${model.brand_code}.webp"/>`
                            : ""
                    }
                </div>
            </div>
        </a>`;
    }

    doAutocompleteLookup = (event) => {
        const input = event.target;
        const form = input.closest("form");
        const lang = document.body.getAttribute("data-autocompletecountry");

        // Always open the autocomplete (this will add the backdrop)
        this.openAutocomplete(input);

        // If the input hasn't changed or is empty, no need to proceed further
        if (!input || this.isSearchUnchanged(input)) {
            if (input.value.trim().length === 0) {
                if (this.isMobileSearch()) {
                    form?.classList.add("hide-close-button");

                    document.querySelector(".autosuggest-output").innerHTML =
                        "";
                    return;
                }

                document.querySelector(".autosuggest-output")?.remove();
            }
            return;
        }

        this.searchQuery = input.value.trim();

        if (this.searchQuery.length === 0) {
            form?.classList.add("hide-close-button");
        } else {
            form?.classList.remove("hide-close-button");
        }
        const urlWithParam = this.createAutocompleteUrl(
            form,
            lang,
            this.searchQuery
        );

        clearTimeout(this.autosuggestionTimeout);
        this.autosuggestionTimeout = setTimeout(
            () => this.fetchAutocompleteSuggestions(input, urlWithParam),
            250
        );
    };

    isSearchUnchanged(input) {
        return (
            this.searchQuery === input.value.trim() &&
            input.value.trim().length !== 0
        );
    }

    createAutocompleteUrl(form, lang, query) {
        const baseUrl = form.getAttribute("data-autocomplete-url");
        const size = tireSize.getForAPI();
        return `${baseUrl}?lang=${lang}&query=${encodeURIComponent(
            query
        )}&size=${encodeURIComponent(size)}`;
    }

    fetchAutocompleteSuggestions(input, url) {
        fetch(url)
            .then((response) => {
                if (!response.ok)
                    throw new Error(`HTTP error! status: ${response.status}`);
                return response.json();
            })
            .then((data) =>
                this.openAutocomplete(input, this.buildAutocompleteOutput(data))
            )
            .catch((error) => console.error("Fetch operation error:", error));
    }

    closeAutocomplete = (e) => {
        if (e.target.closest(".autosuggest-output") !== null) return;
        document.body.classList.remove("autosuggest-open");
        document.querySelector(".autosuggest-backdrop")?.remove();
    };

    addAutocompleteListeners(field) {
        field.addEventListener("keyup", this.doAutocompleteLookup);
        field.addEventListener("click", this.doAutocompleteLookup);
        field.addEventListener("focus", this.doAutocompleteLookup);
    }

    searchIconVisible() {
        let $searchbar = document.querySelector(
            ".navbar-header form.ab-search-form, .navbar-header + form.ab-search-form"
        );

        if (!$searchbar) return false;

        var scrollTop =
            window.pageYOffset ||
            document.documentElement.scrollTop ||
            document.body.scrollTop ||
            0;

        return scrollTop > $searchbar.offsetTop + $searchbar.clientHeight - 60;
    }

    adjustIconToScroll(icon) {
        icon.style.display = this.searchIconVisible() ? "flex" : "none";
    }

    addMobileAutocompleteListeners(field) {
        field.closest(".searchbar").addEventListener("click", (e) => {
            e.preventDefault();
            this.openAutocomplete();
        });

        //Icon

        const icon = document.querySelector(
            ".navbar-header .mobile-search-icon"
        );

        if (icon) {
            icon.addEventListener("click", (e) => {
                e.preventDefault();
                this.openAutocomplete();
            });

            //Scroll

            window.addEventListener("scroll", () => {
                this.adjustIconToScroll(icon);
            });

            this.adjustIconToScroll(icon);
        }
    }
}

window.autosuggestData = new AutoSuggest();

class ChatFSModal {
    constructor() {
        this.$fsChat = null;
        this.scrollTop = 0;
    }

    addChatModalListener() {
        var $icon = document.querySelector(".visible-xs .chat-icon");
        var $bottomIcon = document.querySelector(
            ".tim-collapsed > .visible-xs"
        );
        var $close = document.querySelector(".tim-chat-header > a");

        if (!$icon || !$bottomIcon || !$close) return;

        $icon.addEventListener("click", (e) => {
            e.preventDefault();

            this.scrollTop = window.scrollY;
            document.body.classList.add("chat-is-fixed");

            document.body.scroll(0, this.scrollTop);

            const $tim = document.querySelector(".tim-popup");
            $tim.classList.add("opened");
        });

        $bottomIcon.addEventListener("click", (e) => {
            e.preventDefault();

            if ($bottomIcon.classList.contains("no-modal")) {
                window.open($bottomIcon.href, "_blank").focus();
                return true;
            }

            this.scrollTop = window.scrollY;
            document.body.classList.add("chat-is-fixed");

            document.body.scroll(0, this.scrollTop);

            const $tim = document.querySelector(".tim-popup");
            $tim.classList.add("opened");
        });

        $close.addEventListener("click", (e) => {
            e.preventDefault();
            document.body.classList.remove("chat-is-fixed");
            if (window.innerWidth < 768) {
                window.scrollTo(0, this.scrollTop);
            }
            return false;
        });
    }
}

try {
    const chatModal = new ChatFSModal();

    document.addEventListener("DOMContentLoaded", (event) => {
        chatModal.addChatModalListener();
    });
} catch (e) {
    console.error(e);
}

(function ($) {
    const $document = $(document);

    function sanitizeInput(input) {
        return input.replace(/[\u00A0-\u9999<>\&]/gim, function (i) {
            return "&#" + i.charCodeAt(0) + ";";
        });
    }

    function initChat(message = "") {
        const chatDomain =
            document
                .querySelector("[data-chat-domain]")
                ?.getAttribute("data-chat-domain") ??
            "https://chat.bandenconcurrent.nl/";
        if (message.length > 0) {
            const sanitizedMessage = sanitizeInput(message);
            const encodedMessage = encodeURIComponent(sanitizedMessage);
            const iframeSrc = `${chatDomain}embed?start_message=${encodedMessage}`;

            $(".tim-popup iframe").attr("src", iframeSrc);
        }
        $(".tim-popup").addClass("opened");
    }

    $document.on("click", "[data-start-chat]", function (e) {
        e.preventDefault();
        $(this).blur();
        initChat($(this).attr("data-start-chat"));
    });

    $document.on("submit", ".search-box", function (e) {
        e.preventDefault();
        const $input = $(this).find("input");
        initChat($input.val());
    });

    const urlParams = new URLSearchParams(window.location.search);
    const startChatMessage = urlParams.has("start_chat");
    const chatMessage = urlParams.get("start_chat");

    if (startChatMessage) {
        const decodedMessage = decodeURIComponent(chatMessage);
        initChat(decodedMessage);

        urlParams.delete("start_chat");
        const newUrl =
            window.location.pathname +
            (urlParams.toString() ? "?" + urlParams.toString() : "");
        window.history.replaceState(null, "", newUrl);
    }
})(jQuery);
